import { Component, ElementRef, OnDestroy, OnInit, ViewChild, Injector } from '@angular/core';
import { NgbModal, NgbModalOptions } from '@ng-bootstrap/ng-bootstrap';
import * as _ from 'lodash';
import { forkJoin, Subject, Subscription } from 'rxjs';
import {
  BULK_TEMPLATE_FILES,
  BULK_UPLOAD,
  ColumnDefinition,
  COMMON_CONSTANTS,
  EXCEL_JS,
  MANAGE_LINE_CONST,
  MSISDN_CHANGE_REASONS,
  SIM_SWAP_REASONS,
  SIM_CHANGE_CONST,
  SUSPEND_CONSTANTS,
  VALUE,
  LINE_IDENTIFIER,
  ENTITLEMENT_ACTIVITYNAMES,
  ANALYTICS,
  ColumnDefinitionDateStr
} from '../../../common/core/common.constants';
import { ContentService } from 'src/app/services/content.service';
import { ExportService } from 'src/app/services/export.service';
import { ManageLineService } from 'src/app/services/manage-line.service';
import { UtilsService } from 'src/app/services/utils.service';
import { SuccessComponent } from '../../../shared/components/success/success.component';
import { SubmitBulkUploadComponent } from '../submit-bulk-upload/submit-bulk-upload.component';
import {
  changeNumbersColumnsDefinition,
  restoreColumnsDefinition,
  simSwapColumnsDefinition,
  suspendColumnsDefinition,
  transferColumnsDefinition,
  eSimSwapColumnsDefinition,
  cancelSubscriberColumnsDefinition,
  changeServiceColumnsDefinition,
  TPOPColumnsDefinition
} from '../../../common/models/column-defintion.model';
import { HttpCacheService } from 'src/app/services/http-cache.service';
import { LoaderService } from 'src/app/services/loader.service';
import { WindowServiceService } from 'src/app/services/window-service.service';
import { PDLService } from 'src/app/services/pdl-service.service';
import { environment } from 'src/environments/environment';
import { ChangeServiceBulkSelectionComponent } from 'src/app/change-service/components/change-service-bulk-selection/change-service-bulk-selection.component';
import { ManagePairingService } from 'src/app/services/manage-pairing.service';
import { TpopComponent } from 'src/app/shared/components/tpop/tpop.component';

@Component({
  selector: 'app-common-bulk-upload',
  templateUrl: './common-bulk-upload.component.html',
  styleUrls: ['./common-bulk-upload.component.scss'],
})
export class CommonBulkUploadComponent implements OnInit, OnDestroy {
  authoringContentData: any;
  templateObj: any = [];
  JSonExcel: any;
  bulkFlow: string;
  title: string;
  subheader: string;
  bulkOrInlineFlow: boolean;
  selectedLines: any;
  worksheetname: string;
  uploadJsonData: any = [];
  requests: any = [];
  requestBody: any = {};
  popuperror: any;
  fileToBeDownloaded: string;
  templateType: any;
  isExcel: boolean;
  reasonCode: string;
  logonData: any;
  arrayBuffer: any;
  ngbModalOptions: NgbModalOptions;
  subscriberStatusSucces: number;
  totalInvalidRows: any;
  totalIssuesFound: number;
  inlineError: boolean;
  regex19 = SIM_CHANGE_CONST.REGEX19;
  regex20 = SIM_CHANGE_CONST.REGEX20;
  regex32 = SIM_CHANGE_CONST.REGEX32;
  uploadProgressShow = false;
  authInfo: any;
  validUploadData: any = [];
  chngBulkUploadModalRef: any;
  formateCheck: any;
  restoreMsgFlag: any;
  fileUploadingPercentage: number;
  fileName: any;
  validatingPhoneNumber: any;
  isChangeNumberValidSheet: boolean;
  orgId: any;
  @ViewChild('inputFiles') inputFiles: ElementRef;
  transferMsgFlag: boolean;
  itemsUploadedSuccessfully = 0;
  authoringContentDataBulk: any;
  totalInvalidRecords: number;
  transferNoSelectedLine: any;
  cancelFileUpload = false;
  noOfActiveLines;
  type;
  hideXLSTemplateDownload = true;
  duplicateMSISDN: any;
  duplicateNumberToTransfer: any;
  duplicateMSISDNObj: any;
  duplicateNumberToTransferObj: any;
  transformInlineErrorObject: any = [];
  recordsWithErrors: any = [];
  recordsWithoutErrors: any = [];
  uploadJSONSubscription: Subscription;
  portinLines: any = [];
  requestPortin: any;
  configModel: any = [];
  Ban: any;
  pageNumber: any;
  manageLineDetails: any;
  orgName: any;
  showTechnicalIssuePopup: boolean;
  banListingBlkTop: any;
  voluntarySusp: any;
  dataFetchedFromSubscriber  = new Subject<boolean>();
  dataFetchedFromSubscriberSubs: Subscription;
  isOkta: boolean;
  isTransferBulkReadOnly: boolean;
  remainingPagesCount: any;
  manageLineService: ManageLineService;
  modalService: NgbModal;
  utilsSvc: UtilsService;
  exportSvc: ExportService;
  _loaderSvc: LoaderService;
  contentService: ContentService;
  _cacheSvc: HttpCacheService;
  _windowService: WindowServiceService;
  mngPairingSvc: ManagePairingService;
  pdlService: PDLService;
  stopProcessing: boolean;
  progress: number;
  total = 0;
  setTimeoutRefList: any;
  eSimEnabled:boolean = environment.ENABLE_ESIM;
  selectedBanDetails: any;
  accountType: any;
  disableBulkLineIdentifier: boolean = false;
  showDownloadError: boolean = false;
  responsePageNumber: number;
  tpopError: boolean = true;
  transferNumberLines = [];
  linesWithError = [];
  showTimeErrorBelowReviewStatement = false;
  isUDFDormancyEnabled = environment.ENABLE_UDF_AHUB_2;
  constructor(private injector : Injector) {
    this.manageLineService = this.injector.get<ManageLineService>(ManageLineService);
    this.modalService = this.injector.get<NgbModal>(NgbModal);
    this.utilsSvc = this.injector.get<UtilsService>(UtilsService);
    this.exportSvc = this.injector.get<ExportService>(ExportService);
    this._loaderSvc = this.injector.get<LoaderService>(LoaderService);
    this.contentService = this.injector.get<ContentService>(ContentService);
    this._cacheSvc = this.injector.get<HttpCacheService>(HttpCacheService);
    this._windowService = this.injector.get<WindowServiceService>(WindowServiceService);
    this.pdlService = this.injector.get<PDLService>(PDLService);
    this.mngPairingSvc = this.injector.get<ManagePairingService>(ManagePairingService);
   }

  ngOnInit() {
    this.authoringContentData = this.utilsSvc.getContentDataFromSession();
    this.subscriberStatusSucces = 0;
    this.isTransferBulkReadOnly = this.utilsSvc.isReadOnly_AhubCare_UserActivity(ENTITLEMENT_ACTIVITYNAMES.TRANSFER_NUMBER);
    this.fileUploadingPercentage = 0;
    this.bulkOrInlineFlow = ContentService.GetCache(BULK_UPLOAD.BULK_OR_INLINE_FLOW);
    this.bulkFlow = ContentService.GetCache(BULK_UPLOAD.BULK_FLOW_KEY);
    this.templateType = ContentService.GetCache(BULK_UPLOAD.TEMPLATE_KEY);
    this.banListingBlkTop = HttpCacheService.GetCache(BULK_UPLOAD.BANLISTNG_TOP_BLKUPLD);
    this.isOkta =  this._cacheSvc.getFromSessionStorage(COMMON_CONSTANTS.AUTH_TYPE) !== COMMON_CONSTANTS.IAM_KEY ?  true : false;
    this.configModel = this.utilsSvc.createConfigModel();
    this.selectedBanDetails = JSON.parse(this._cacheSvc.getFromSessionStorage(MANAGE_LINE_CONST.SELECTED_BAN_DETAIL));
    this.accountType = this.selectedBanDetails?.accountType || '';
    this.pageNumber = COMMON_CONSTANTS.DIGITS.ONE;
    this.ngbModalOptions = {
      backdrop: 'static',
      keyboard: false,
      container: '#am-container-custom',
    };
    this.Ban = this._cacheSvc.getFromSessionStorage(COMMON_CONSTANTS.BAN_NUMBER_KEY) != null ?
      this._cacheSvc.getFromSessionStorage(COMMON_CONSTANTS.BAN_NUMBER_KEY) : '';
    if (this.bulkFlow === BULK_UPLOAD.LINE_IDENTIFIER && (!this.banListingBlkTop) && (!this.bulkOrInlineFlow)) {
      this.disableBulkLineIdentifier = true;
      let PAGE_CONST;
      this.responsePageNumber = 0;
      PAGE_CONST = COMMON_CONSTANTS.RECORDS_PER_PAGE_TEA_API;
      this._loaderSvc.start();
      const lineStatus = ['A', 'S'];
      const isTotalMsisdns = true;
      this.manageLineService.getManageLineDetail(this.Ban, this.pageNumber, lineStatus, isTotalMsisdns).subscribe((response) => {
        if (response != null) {
          if(response.totalPages == COMMON_CONSTANTS.DIGITS.ONE){
            this.disableBulkLineIdentifier = false;
          }
          this.manageLineDetails = response;
          this.responsePageNumber = Number(response.pageNumber);
          if (response.endOfResult == "false") {
            this.remainingPagesCount = (response.banInfo?.totalMsisdnsInUse - PAGE_CONST) / PAGE_CONST;
            if (this.remainingPagesCount !== COMMON_CONSTANTS.DIGITS.ZERO) {
              this.remainingPagesCount = Math.ceil(this.remainingPagesCount);
            } else {
              this.remainingPagesCount = Math.round(this.remainingPagesCount);
            }
            const remainingCalls = [];
            for (let i = COMMON_CONSTANTS.DIGITS.ONE; i <= this.remainingPagesCount; i++) {
              this.pageNumber = i + COMMON_CONSTANTS.DIGITS.ONE;
              remainingCalls.push(this.manageLineService.getManageLineDetail(this.Ban, this.pageNumber, lineStatus, isTotalMsisdns));
            }
            this.fetchRemainingPages(remainingCalls);
          }
        }
        if (this.responsePageNumber == this.pageNumber) {
          this._loaderSvc.stop();
          this.downloadDataForLineIdentifier();
          this.dataFetchedFromSubscriber.next(true);
        }
      },(error) => {
        this._loaderSvc.stop();
        this.showDownloadError = true;
      });
    }
    this.orgId = this._cacheSvc.getFromSessionStorage(COMMON_CONSTANTS.ORG_ID_KEY) != null ? this._cacheSvc.getFromSessionStorage(COMMON_CONSTANTS.ORG_ID_KEY) : '';
    if (this.templateType === BULK_UPLOAD.XLSX_TXT) {
      this.isExcel = true;
    } else if (this.templateType === BULK_UPLOAD.CSV_TXT) {
      this.isExcel = false;
    }
    if(this.bulkFlow === BULK_UPLOAD.STRATEGIC_PORT_IN || this.bulkFlow === BULK_UPLOAD.TPOP_KEY){
      this.exportSvc.uploadJson.next(null);
    }
    this.onUploadJson();
    this.getTitleAndWorkSheetName();
    this.getSubHeader();
    this.getSomeData();
    if (this.bulkFlow === BULK_UPLOAD.LINE_IDENTIFIER && (this.banListingBlkTop || this.bulkOrInlineFlow)) {
      this.downLoadSheetOnInit();
    }
    this.dataFetchedFromSubscriberSubs = this.dataFetchedFromSubscriber.subscribe(data => {
      if (data != null && data === true) {
        this.downLoadSheetOnInit();
      }
    });

    if (this.isTransferNumberTransaction()) {
      this.generateModalViewTag({
        eventAction: ANALYTICS.LOAD,
        modalName: this.title,
        stage: ANALYTICS.STAGE_START,
        name: this.title
      });
    }
  }

  recursiveAPICall(){
    this.manageLineService.getManageLineDetail(this.Ban, this.pageNumber).subscribe((responseRecursive) => {
      this.responsePageNumber = Number(responseRecursive.pageNumber);
      for (let j = COMMON_CONSTANTS.DIGITS.ZERO; j < (responseRecursive.subscribers.length); j++) {
        this.manageLineDetails.subscribers.push(responseRecursive.subscribers[j]);
      }
      if (Number(responseRecursive.totalNoOfRecords) == this.manageLineDetails.subscribers.length) {
        this.disableBulkLineIdentifier = false;
        this.downloadDataForLineIdentifier();
        this.dataFetchedFromSubscriber.next(true);
      }
    },(error) => {
      this.showDownloadError = true;
    });
  }

  fetchRemainingPages(apiCalls){
    forkJoin(apiCalls).subscribe(
      (responses: any) => {
        this._loaderSvc.stop();
        responses.forEach((responseRecursive) => {
        this.manageLineDetails?.subscribers?.push(...responseRecursive.subscribers);
      });
      const lastResponse = responses[responses.length - 1];
      if (lastResponse && Number(lastResponse.totalNoOfRecords) === this.manageLineDetails?.subscribers?.length){
        this.disableBulkLineIdentifier = false;
        this.downloadDataForLineIdentifier();
        this.dataFetchedFromSubscriber.next(true);
      }
    }, 
    (error) => {
      this._loaderSvc.stop();
      this.showDownloadError = true;
    }
  );
}

  ngOnDestroy(): void {
    this.uploadJSONSubscription.unsubscribe();
    this.dataFetchedFromSubscriberSubs.unsubscribe();
  }

  downLoadSheetOnInit() {
    if (this.bulkFlow === BULK_UPLOAD.LINE_IDENTIFIER) {
      if (this.isExcel) {
        this.exportAsXLSX();
      } else {
        this.exportAsCSV();
      }
    }
  }
  exportXLSX(){
    ContentService.SetCache(BULK_UPLOAD.TEMPLATE_KEY, BULK_UPLOAD.XLSX_TXT);
    ContentService.SetCache(BULK_UPLOAD.BULK_FLOW_KEY, this.bulkFlow);
    ContentService.SetCache(BULK_UPLOAD.BULK_OR_INLINE_FLOW, false);
    this.templateType = BULK_UPLOAD.XLSX_TXT;
    this.isExcel = true;
    this.exportAsXLSX();
  }

  exportCSV(){
    ContentService.SetCache(BULK_UPLOAD.TEMPLATE_KEY, BULK_UPLOAD.CSV_TXT);
    ContentService.SetCache(BULK_UPLOAD.BULK_FLOW_KEY, this.bulkFlow);
    ContentService.SetCache(BULK_UPLOAD.BULK_OR_INLINE_FLOW, false);
    this.templateType = BULK_UPLOAD.CSV_TXT;
    this.isExcel = false;
    this.exportAsCSV();
  }


  handleSpecificValidations(res) {
    if (this.validatingPhoneNumber > 0) {
      switch (this.bulkFlow) {
        case BULK_UPLOAD.CHANGE_PHONE_KEY:
          // need to impliment
          this.totalInvalidRows = this.validateChangeNumberSheet(res);
          break;
        case BULK_UPLOAD.SIM_SWAP_KEY:
          // need to impliment
          this.totalInvalidRows = this.validateSimSwapSheet(res);
          break;
        case BULK_UPLOAD.SUSPEND_KEY:
          this.totalInvalidRows = this.validateSuspendSheet(res);
          ContentService.SetCache(BULK_UPLOAD.SUSPEND_FLOW_DATA, res);
          break;
        case BULK_UPLOAD.RESTORE_KEY:
          this.totalInvalidRows = this.validateRestoreSheet(res);
          break;
        case BULK_UPLOAD.TRANSFER_NUMBERS:
          this.totalIssuesFound = this.validateTransferNumberSheet(res);
          break;
        case BULK_UPLOAD.LINE_IDENTIFIER:
          this.totalInvalidRows = this.validateLineIdentifierSheet(res);
          break;
        case BULK_UPLOAD.CANCEL_SUBSCRIBER:
          this.totalInvalidRows = this.validateCancelSubscriberSheet(res);
          break;
        case BULK_UPLOAD.CHANGE_SERVICE:
          this.totalInvalidRows = this.validateChangeServiceSheet(res);
          break;
        case BULK_UPLOAD.MANAGE_PAIRING:
          // Validation will happen in submit bulk component and allow
          // users to down errors
          this.totalInvalidRows = 0;
          break;
        case BULK_UPLOAD.STRATEGIC_PORT_IN:
          // Validation will happen in submit bulk component and allow
          // users to down errors
          this.totalInvalidRows = 0;
          break;
        case BULK_UPLOAD.TPOP_KEY:
          this.totalInvalidRows = this.validateTpopSheet(res);
          break;
      }

      if (this.bulkFlow !== BULK_UPLOAD.TPOP_KEY && this.bulkFlow !== BULK_UPLOAD.TRANSFER_NUMBERS && this.formateCheck &&
        ((!this.formateCheck.validFormate && this.bulkFlow === BULK_UPLOAD.RESTORE_KEY) ||
          this.formateCheck.validFormate || !this.isExcel)) {
        if (this.totalInvalidRows === 0) {
          this.ngbModalOptions = {
            backdrop: 'static',
            keyboard: false,
            container: '#am-container-custom',
          };
          ContentService.SetCache(COMMON_CONSTANTS.LENGTH_TXT, res.length);
          this.afterSuccesfullyUploaded(res, this.totalInvalidRows);
          this.popuperror =  this.authoringContentData?.bulkFlow?.popUpErrorTxt ? this.authoringContentData.bulkFlow.popUpErrorTxt : '';
        } else if (this.totalInvalidRows < 0) {
          if (res.length === 0) {
            this.popuperror = this.authoringContentData?.bulkFlow?.popUpErrorTxt ? this.authoringContentData.bulkFlow.popUpErrorTxt : '';
          } else {
            if (this.bulkFlow === BULK_UPLOAD.RESTORE_KEY) {
              if (this.restoreMsgFlag) {
                this.restoreMsgFlag = this.makingErrorMessageForRestore(res);
                if (this.restoreMsgFlag) {
                  this.showPhoneErrorMsg();
                }
              } else {
                this.popuperror = this.authoringContentData?.bulkFlow?.errorWhileUploadingTxt ?
                  this.authoringContentData.bulkFlow.errorWhileUploadingTxt : '';
              }
            } else {
              this.showPhoneErrorMsg();
            }
          }
        } else if (this.totalInvalidRows > 0) {
          this.ngbModalOptions = {
            backdrop: 'static',
            keyboard: false,
            container: '#am-container-custom',
          };
          if (this.bulkFlow === BULK_UPLOAD.SUSPEND_KEY) {
            ContentService.SetCache(COMMON_CONSTANTS.LENGTH_TXT, res.length);
            this.afterSuccesfullyUploaded(res, this.totalInvalidRows);
          } else if (this.bulkFlow === BULK_UPLOAD.CHANGE_PHONE_KEY) {
            if (!this.isChangeNumberValidSheet) {
              this.popuperror = this.authoringContentData?.bulkFlow?.errorWhileUploadingTxt ?
                this.authoringContentData.bulkFlow.errorWhileUploadingTxt : '';
            } else {
              this.afterSuccesfullyUploaded(res, this.totalInvalidRows);
            }
          } else {
            this.afterSuccesfullyUploaded(res, this.totalInvalidRows);
          }
        }
      } else if (this.formateCheck &&
        (this.formateCheck.validFormate && this.bulkFlow === BULK_UPLOAD.TRANSFER_NUMBERS)) {
        ContentService.SetCache(COMMON_CONSTANTS.LENGTH_TXT, res.length);
        this.afterSuccesfullyUploaded(res, this.totalIssuesFound);
      } else if(this.formateCheck?.validFormate && this.bulkFlow === BULK_UPLOAD.TPOP_KEY){
          ContentService.SetCache(COMMON_CONSTANTS.LENGTH_TXT, res.length);
          this.uploadJsonData = res;
          ContentService.SetCache(BULK_UPLOAD.BULK_UPLOAD_REQUEST_KEY, this.uploadJsonData);
          this.tpopError = false;
      } else {
        this.popuperror = this.authoringContentData?.bulkFlow?.errorWhileUploadingTxt ? this.authoringContentData.bulkFlow.errorWhileUploadingTxt : '';
      }
    }
  }

  bulkRequestBody() {
    this.uploadJsonData = [...this.uploadJsonData];
    const authInfo = JSON.parse(this._cacheSvc.getFromSessionStorage(MANAGE_LINE_CONST.AUTHENTICATION_INFO));
    return _.map(this.uploadJsonData, (data) => {
      return {
        orgId: this.orgId,
        logonId: authInfo ? authInfo.logonID : COMMON_CONSTANTS.LOGON_ID,
        email: authInfo ? authInfo.logonEmail : COMMON_CONSTANTS.LOGON_ID,
        msisdn: data.PhoneNumber,
        ban: this._cacheSvc.getFromSessionStorage(MANAGE_LINE_CONST.BAN)
      };
    });
  }

  openTpopSuccess(successToken){
    const GEN_POP  = {
      tpopGenerationTransRefNumber: successToken,
      transactionAction: "bulkTpop"
    }; 
    const GPOP_Model = this.modalService.open(TpopComponent, {
      backdrop: "static",
      keyboard: false,
      centered: false,
      container: "#am-container-custom",
    });
    GPOP_Model.componentInstance.GEN_POP = GEN_POP; 
  }

  submitTpopPinDataAfterUpload() {
    const requestPayLoad = {
      targetServiceName: 'tpop-generation',
      ban: this._cacheSvc.getFromSessionStorage(MANAGE_LINE_CONST.BAN),
      requests: this.bulkRequestBody(),
    };
    this._loaderSvc.start();
    this.manageLineService.bulkChangeNmberProcessor(requestPayLoad)?.subscribe((data) => {
    this._loaderSvc.stop();
    this.manageLineService.close();
    let successToken = data.token;
    this.openTpopSuccess(successToken);
    }, (error) => {
      this._loaderSvc.stop();
      this.manageLineService.close();
      this.utilsSvc.errorHandling(error);
    });
  }

  assignPopupError(bulkFlow) {
    switch (bulkFlow) {
      case BULK_UPLOAD.TRANSFER_NUMBERS:
        this.popuperror = this.authoringContentData?.transferNumberAuthoring?.noDataFoundErrMsg ?
          this.authoringContentData.transferNumberAuthoring.noDataFoundErrMsg : '';
        break;
      case BULK_UPLOAD.LINE_IDENTIFIER:
        this.popuperror = this.authoringContentData?.lineIdentifierAuthoring?.noDataFoundErrMsg ?
          this.authoringContentData.lineIdentifierAuthoring.noDataFoundErrMsg : '';
        break;
      default:
        this.popuperror = this.authoringContentData?.bulkFlow?.popUpErrorTxt ?
          this.authoringContentData.bulkFlow.popUpErrorTxt : '';
        break;
    }
  }

  onUploadJson() {
    this.uploadJSONSubscription = this.exportSvc.uploadJson.subscribe((response) => {
      if (response != null) {
        let res: any = [];
        this.templateType = ContentService.GetCache(BULK_UPLOAD.TEMPLATE_KEY);
        if (this.templateType === BULK_UPLOAD.CSV_TXT) {
          for (const item of response) {
            res.push(item);
          }
        } else {
          res = response;
        }
        this.formateCheck = res;
        if (res?.length > 0) {
          this.validatePhoneNumberKey(res);
        } else {
          this.assignPopupError(this.bulkFlow);
        }
      }
    });
  }

  getSomeData() {
    switch (this.bulkFlow) {
      case BULK_UPLOAD.CHANGE_PHONE_KEY:
        if (!this.bulkOrInlineFlow) {
          const tempdata: any = {};
          tempdata.PhoneNumber = '';
          tempdata.Preferred_Area_Code = '';
          tempdata.Reason_For_Change = '';
          this.templateObj.push(tempdata);
          this.getTemplateType();
        } else if (this.bulkOrInlineFlow) {
          this.BulkOrInlineFLowForChangePhoneKey();
        }
        break;
      case BULK_UPLOAD.SIM_SWAP_KEY:
        this.downloadSimSwapData();
        break;
      case BULK_UPLOAD.SUSPEND_KEY:
        if (!this.bulkOrInlineFlow) {
          this.getTemplateType();
        } else if (this.bulkOrInlineFlow) {
          this.bulkOrInlineFlowForSuspendKey();
        }
        break;
      case BULK_UPLOAD.RESTORE_KEY:
        this.downloadRestoreData();
        break;
      case BULK_UPLOAD.TRANSFER_NUMBERS:
        if (!this.bulkOrInlineFlow) {
          this.getTemplateType();
          this.getDataEmptyTransferNumber();
        } else if (this.bulkOrInlineFlow) {
          this.makingDataForTransferNumber();
        }
        break;
      case BULK_UPLOAD.LINE_IDENTIFIER:
        if (this.bulkOrInlineFlow || this.banListingBlkTop) {
          this.downloadDataForLineIdentifier();
        }
        break;
      case BULK_UPLOAD.CANCEL_SUBSCRIBER:
        this.setCancelSubscriberTemplateData();
        break;
      case BULK_UPLOAD.CHANGE_SERVICE:
        this.setFileToBeDownloaded(BULK_TEMPLATE_FILES.CHANGE_SERVICE, BULK_TEMPLATE_FILES.CHANGE_SERVICE_CSV);
        break;
      case BULK_UPLOAD.MANAGE_PAIRING:
        if (this.bulkOrInlineFlow) {
          this.makingDataForManagePairing();
        }
        break;
      case BULK_UPLOAD.TPOP_KEY:
          const temp: any = {};
          temp.AccountNumber = '';
          temp.PhoneNumber = '';
          this.templateObj.push(temp);
          this.getTemplateType();
        break;
    }
  }
  BulkOrInlineFLowForChangePhoneKey() {
    let temp1: any;
    if (this.selectedLines) {
      for (const line of this.selectedLines) {
        temp1 = {};
        temp1.PhoneNumber = Number(line.msisdn);
        temp1.Preferred_Area_Code = '';
        temp1.Reason_For_Change = '';
        this.templateObj.push(temp1);
      }
    }
  }
  bulkOrInlineFlowForSuspendKey() {
    let temp1: any;
    if (this.selectedLines) {
      // tslint:disable-next-line: prefer-for-of
      for (const line of this.selectedLines) {
        temp1 = {};
        temp1.PhoneNumber = Number(line.msisdn);
        temp1.Suspend_reason = '';
        temp1.Suspend_ApproverType = '';
        temp1.Suspend_start_date = '';
        temp1.Suspend_end_date = '';
        this.templateObj.push(temp1);
      }
    }
  }

  getDataEmptyTransferNumber() {
    this.templateObj = [];
    let temp1: any;

      temp1 = {};
      temp1[BULK_UPLOAD.MSISDN_NUMBER_TXT] = "";
      temp1[BULK_UPLOAD.NUMBER_TO_TRANSFER_TXT] = "";
      temp1[BULK_UPLOAD.CARRIER_ACCOUNT_NUMBER] = "";
      temp1[BULK_UPLOAD.ACCOUNT_PIN_OR_PASSWORD] = "";
      temp1[BULK_UPLOAD.PORT_DATE_TXT] = "";
      temp1[BULK_UPLOAD.PORT_START_TIME_TXT] = "";

      this.templateObj.push(temp1);
  }

  private makingDataForTransferNumber() {
    if (this.selectedLines) {
      this.templateObj = [];
      let temp1: any;
      // tslint:disable-next-line: prefer-for-of
      for (const line of this.selectedLines) {
        temp1 = {};
        temp1[BULK_UPLOAD.MSISDN_NUMBER_TXT] = Number(line.msisdn);
        temp1[BULK_UPLOAD.NUMBER_TO_TRANSFER_TXT] = '';
        temp1[BULK_UPLOAD.CARRIER_ACCOUNT_NUMBER] = '';
        temp1[BULK_UPLOAD.ACCOUNT_PIN_OR_PASSWORD] = '';
        temp1[BULK_UPLOAD.PORT_DATE_TXT] = '';
        temp1[BULK_UPLOAD.PORT_START_TIME_TXT] = '';

        this.templateObj.push(temp1);
      }
    }

  }

  getIncomingfileXlsx(event) {
    this.uploadProgressShow = true;
    this.cancelFileUpload = false;
    const testData = event;
    if (event.target.files.length > 0) {
      this.exportSvc.incomingfile(testData);
      this.fileName = event.target.files[0].name;
    }
    if (this.fileName != null) {
      const extention = this.fileName.substr(this.fileName.length - 4);
      if (extention === 'xlsx') {
        this.importXLSX();
      } else {
        this.popuperror = this.authoringContentData.bulkFlow.fileTypeNotSupported;
      }
    }
  }

  removeTpopFile(){
    this.uploadProgressShow = false;
    this.tpopError = true;
  }

  stopValidationSetTimeout() {
    this.stopProcessing = true;
    this.fileUploadingPercentage = 0;
    this.total = 0;
    if (this.setTimeoutRefList) {
      for (let i = this.progress;  i < this.setTimeoutRefList.length; i++) {
        clearTimeout(this.setTimeoutRefList[i]);
      }
    }
  }

  resetModal() {
    this.stopValidationSetTimeout();
    this.cancelFileUpload = true;
  }

  getIncomingfileCsv(event) {
    this.uploadProgressShow = true;
    const testData = event;
    this.exportSvc.incomingfile(testData);
    if (event.target.files.length > 0) {
      this.fileName = event.target.files[0].name;
    }
    if (this.fileName != null) {
      const extention = this.fileName.substr(this.fileName.length - 3);
      if (extention === 'csv') {
        this.importXLSX();
      } else {
        this.popuperror = this.authoringContentData.bulkFlow.popUpErrorExtention;
      }
    }
  }

  importXLSX() {
    this.stopProcessing = false;
    if (!this.cancelFileUpload) {
      this.exportSvc.Upload();
    }
    this.inputFiles.nativeElement.querySelector(BULK_TEMPLATE_FILES.FORM_INPUT).value = null;
  }

  exportAsXLSX() {
    this.hideXLSTemplateDownload = false;
    ContentService.SetCache('template', 'xlsx');
    const baseurl = BULK_TEMPLATE_FILES.BASE_URL;
    this.getTemplateType();

    if (!this.bulkOrInlineFlow  && this.bulkFlow !== BULK_UPLOAD.TRANSFER_NUMBERS) {
      if (this.bulkFlow === BULK_UPLOAD.LINE_IDENTIFIER) {
        this.exportSvc.exportAsExcelFile(this.templateObj, this.worksheetname);
      } else if (this.bulkFlow === BULK_UPLOAD.CHANGE_SERVICE) {
        const modalRef = this.modalService.open(ChangeServiceBulkSelectionComponent, this.ngbModalOptions);
        modalRef.componentInstance.templateType = BULK_UPLOAD.XLSX_TXT;
      } else if (this.bulkFlow === BULK_UPLOAD.TPOP_KEY) {
        this.exportSvc.exportAsExcelFile(this.templateObj, this.worksheetname);
      } else {
        this._windowService.redirectTo(this._windowService.location.origin + baseurl + this.fileToBeDownloaded);
      }
    } else {
      this.exportSvc.exportAsExcelFile(this.templateObj, this.worksheetname);
    }
    setTimeout(() => {
      this.hideXLSTemplateDownload = true;
    }, 1000);
  }

  exportAsCSV() {
    const baseurl = BULK_TEMPLATE_FILES.BASE_CSVURL;
    this.getTemplateType();

    if (!this.bulkOrInlineFlow) {
      if (this.bulkFlow === BULK_UPLOAD.LINE_IDENTIFIER) {
        this.exportSvc.exportAsCsvFile(this.templateObj, this.worksheetname);
      } else if (this.bulkFlow === BULK_UPLOAD.CHANGE_SERVICE) {
        const modalRef = this.modalService.open(ChangeServiceBulkSelectionComponent, this.ngbModalOptions);
        modalRef.componentInstance.templateType = BULK_UPLOAD.CSV_TXT;
      }
      else {
        this._windowService.redirectTo(this._windowService.location.origin + baseurl + this.fileToBeDownloaded);
      }

    } else {
      this.exportSvc.exportAsCsvFile(this.templateObj, this.worksheetname);
    }
  }

  setValOrDblHyphen(val) {
    if (val != null) {
      return val;
    }
    return COMMON_CONSTANTS.DOUBLE_HYPHEN;
  }

  downloadDataForLineIdentifier() {
    let dynamicColumns: any;
    this.templateObj = [];
    if (this.banListingBlkTop) {
      dynamicColumns = {};
      dynamicColumns[BULK_UPLOAD.BAN_TXT] = COMMON_CONSTANTS.STRING_EMPTY;
      dynamicColumns[BULK_UPLOAD.PHONE_NUMBER_TXT] = COMMON_CONSTANTS.STRING_EMPTY;
      for (const config of this.configModel) {
        if(environment.ENABLE_DH_UDF && config.configName == LINE_IDENTIFIER.CONFIG_UDFID6){
          dynamicColumns[this.authoringContentData.bulkFlow.bulkUploadUDFExtraColumnDescription + COMMON_CONSTANTS.NEW_LINE_R + BULK_UPLOAD.UPDATED_TXT + COMMON_CONSTANTS.STRING_SPACE + (config.configLabel + COMMON_CONSTANTS.STRING_SPACE + config.configDesc).trim()] = COMMON_CONSTANTS.STRING_EMPTY;
        } else{
          dynamicColumns[BULK_UPLOAD.UPDATED_TXT + COMMON_CONSTANTS.STRING_SPACE + (config.configLabel + COMMON_CONSTANTS.STRING_SPACE + config.configDesc).trim()] = COMMON_CONSTANTS.STRING_EMPTY;
        }
      }

      this.templateObj.push(dynamicColumns);
      return;
    }
    if(this.bulkOrInlineFlow){
     this.convertIntoSubscriberResponse(this.selectedLines);
    }

    this.getDataForLineIdentifier();
  }

  getDataForLineIdentifier() {

    for (let i = COMMON_CONSTANTS.DIGITS.ZERO; i < this.manageLineDetails.subscribers.length; i++) {
      if (this.manageLineDetails.subscribers[i].lineStatus.description !== MANAGE_LINE_CONST.CANCELED &&
        this.manageLineDetails.subscribers[i].lineStatus.description !== MANAGE_LINE_CONST.RESERVED) {
        this.checkUDFConfigModelAndUpdateInTemplateObj(i);
      }
    }
  }
  checkUDFConfigModelAndUpdateInTemplateObj(parentIndex){
    let dynamicColumns: any;
    dynamicColumns = {};
    dynamicColumns[BULK_UPLOAD.BAN_TXT] = this.Ban;
    dynamicColumns[BULK_UPLOAD.PHONE_NUMBER_TXT] = Number(this.manageLineDetails.subscribers[parentIndex].msisdn);
    for (const config of this.configModel) {
      let currentTxtKey = BULK_UPLOAD.CURRENT_TXT + COMMON_CONSTANTS.STRING_SPACE + (config.configLabel + COMMON_CONSTANTS.STRING_SPACE + config.configDesc).trim();
      let updatedTxtKey = BULK_UPLOAD.UPDATED_TXT + COMMON_CONSTANTS.STRING_SPACE + (config.configLabel + COMMON_CONSTANTS.STRING_SPACE + config.configDesc).trim();
      if (config.configName === LINE_IDENTIFIER.CONFIG_UDFID1) {
        dynamicColumns[currentTxtKey] = this.setValOrDblHyphen(this.manageLineDetails.subscribers[parentIndex].lineIdentifier[LINE_IDENTIFIER.CONFIG_UDF1]);
        dynamicColumns[updatedTxtKey] = COMMON_CONSTANTS.STRING_EMPTY;
      } else if (config.configName === LINE_IDENTIFIER.CONFIG_UDFID2) {
        dynamicColumns[currentTxtKey] = this.setValOrDblHyphen(this.manageLineDetails.subscribers[parentIndex].lineIdentifier[LINE_IDENTIFIER.CONFIG_UDF2]);
        dynamicColumns[updatedTxtKey] = COMMON_CONSTANTS.STRING_EMPTY;
      } else if (config.configName === LINE_IDENTIFIER.CONFIG_UDFID3) {
        dynamicColumns[currentTxtKey] = this.setValOrDblHyphen(this.manageLineDetails.subscribers[parentIndex].lineIdentifier[LINE_IDENTIFIER.CONFIG_UDF3]);
        dynamicColumns[updatedTxtKey] = COMMON_CONSTANTS.STRING_EMPTY;
      } else if (config.configName === LINE_IDENTIFIER.CONFIG_UDFID4) {
        dynamicColumns[currentTxtKey] = this.setValOrDblHyphen(this.manageLineDetails.subscribers[parentIndex].lineIdentifier[LINE_IDENTIFIER.CONFIG_UDF4]);
        dynamicColumns[updatedTxtKey] = COMMON_CONSTANTS.STRING_EMPTY;
      } else if (config.configName === LINE_IDENTIFIER.CONFIG_UDFID5) {
        dynamicColumns[currentTxtKey] = this.setValOrDblHyphen(this.manageLineDetails.subscribers[parentIndex].lineIdentifier[LINE_IDENTIFIER.CONFIG_UDF5]);
        dynamicColumns[updatedTxtKey] = COMMON_CONSTANTS.STRING_EMPTY;
      }  else if (config.configName === LINE_IDENTIFIER.CONFIG_UDFID6 && environment.ENABLE_DH_UDF) {
        dynamicColumns[currentTxtKey] = this.setValOrDblHyphen(this.manageLineDetails.subscribers[parentIndex].lineIdentifier[LINE_IDENTIFIER.CONFIG_UDF6]);
        dynamicColumns[this.authoringContentData.bulkFlow.bulkUploadUDFExtraColumnDescription + COMMON_CONSTANTS.NEW_LINE_R + updatedTxtKey] = COMMON_CONSTANTS.STRING_EMPTY;
      } 
      // add UDF6 to UDF10 columns in templateObj if isUDFDormancyEnabled is true
      if(this.isUDFDormancyEnabled){
        dynamicColumns = this.addUDFOrgColumnInTemplateObj(dynamicColumns, config, currentTxtKey, updatedTxtKey, parentIndex);
      }
    }
    this.templateObj.push(dynamicColumns);
  }

  // add UDF6 to UDF10 columns in dynamicColumns and return the updated dynamicColumns
  addUDFOrgColumnInTemplateObj(dynamicColumns : any, config:any, currentTxtKey:any, updatedTxtKey:any, parentIndex:any) {
    if (config.configName === LINE_IDENTIFIER.CONFIG_UDFID7) {
      dynamicColumns[currentTxtKey] = this.setValOrDblHyphen(this.manageLineDetails.subscribers[parentIndex].lineIdentifier[LINE_IDENTIFIER.CONFIG_UDF7]);
      dynamicColumns[updatedTxtKey] = COMMON_CONSTANTS.STRING_EMPTY;
    }
    else if (config.configName === LINE_IDENTIFIER.CONFIG_UDFID8) {
      dynamicColumns[currentTxtKey] = this.setValOrDblHyphen(this.manageLineDetails.subscribers[parentIndex].lineIdentifier[LINE_IDENTIFIER.CONFIG_UDF8]);
      dynamicColumns[updatedTxtKey] = COMMON_CONSTANTS.STRING_EMPTY;
    }
    else if (config.configName === LINE_IDENTIFIER.CONFIG_UDFID9) {
      dynamicColumns[currentTxtKey] = this.setValOrDblHyphen(this.manageLineDetails.subscribers[parentIndex].lineIdentifier[LINE_IDENTIFIER.CONFIG_UDF9]);
      dynamicColumns[updatedTxtKey] = COMMON_CONSTANTS.STRING_EMPTY;
    }
    else if (config.configName === LINE_IDENTIFIER.CONFIG_UDFID10) {
      dynamicColumns[currentTxtKey] = this.setValOrDblHyphen(this.manageLineDetails.subscribers[parentIndex].lineIdentifier[LINE_IDENTIFIER.CONFIG_UDF10]);
      dynamicColumns[updatedTxtKey] = COMMON_CONSTANTS.STRING_EMPTY;
    }
    return dynamicColumns
  }
  convertIntoSubscriberResponse(selectedLines) {
    this.manageLineDetails = {};
    this.manageLineDetails.subscribers = selectedLines;
    if (this.manageLineDetails?.subscribers) {
      this.manageLineDetails.subscribers.forEach((item) => {
        item.lineStatus = {};
        item.lineStatus.description = item.statusCode;
      });
    }

  }

  downloadSimSwapData() {
    if (!this.bulkOrInlineFlow) {
      this.getTemplateType();
    } else {
      this.downloadSimSwapDataForBulkInlineFlow();
    }
  }
  downloadSimSwapDataForBulkInlineFlow(){
    let tempSelectedLines: any;
    if (this.selectedLines) {
      this.selectedLines.forEach((element) => {
        tempSelectedLines = {};
        tempSelectedLines.PhoneNumber = element?.msisdn ? Number(element.msisdn) : '';
        tempSelectedLines.OldSim = '';
        if(this.eSimEnabled){
          tempSelectedLines[BULK_UPLOAD.BULK_SIMSWAP_EID_Txt] = '';
          tempSelectedLines[BULK_UPLOAD.BULK_ESIMSWAP_NEWSIM_Txt] = '';
        }else{
          tempSelectedLines.NewSim = '';
        }
        tempSelectedLines.Reason_For_Change = '';
        if(this.eSimEnabled){
          tempSelectedLines[EXCEL_JS.NOTE_ESIM_SWAP] = '';
        }else{
          tempSelectedLines[EXCEL_JS.NOTE_SIM_SWAP] = '';
        }
        this.templateObj.push(tempSelectedLines);
      });
    }
  }

  downloadRestoreData() {
    if (!this.bulkOrInlineFlow) {
      const temp: any = {};
      temp.PhoneNumber = '';
      temp.RestoreDate = '';
      this.templateObj.push(temp);
      this.getTemplateType();

    } else if (this.bulkOrInlineFlow) {
      let temp1: any;
      if (this.selectedLines) {
        // tslint:disable-next-line: prefer-for-of
        for (const line of this.selectedLines) {
          temp1 = {};
          temp1.PhoneNumber = line?.msisdn ? Number(line.msisdn) : '';
          temp1.RestoreDate = '';
          temp1[EXCEL_JS.RESTORE_KEY_NOTE] = '';
          this.templateObj.push(temp1);
        }
      }
    }
  }

  mapReasons(reason) {
    switch (reason) {
      case SUSPEND_CONSTANTS.TEMP_SUSPEND_TXT:
      case SUSPEND_CONSTANTS.TEMP_SUSPEND_UNDERSCORE_TXT:
        this.reasonCode = SUSPEND_CONSTANTS.TEMP_SUSPEND;
        break;
      case SUSPEND_CONSTANTS.SEASONAL_SUSPEND_TXT:
      case SUSPEND_CONSTANTS.SEASONAL_SUSPEND_UNDERSCORE_TXT:
        this.reasonCode = SUSPEND_CONSTANTS.SEASONAL_SUSPEND;
        break;
      case SUSPEND_CONSTANTS.SUSPEND_WITHOUT_CHARGES_TXT:
      case SUSPEND_CONSTANTS.SUSPEND_WITHOUT_CHARGES_UNDERSCORE_TXT:
        this.reasonCode = SUSPEND_CONSTANTS.SUSPEND_WITHOUT_CHARGES;
        break;
      case SUSPEND_CONSTANTS.SUSPEND_WITH_CHARGES_TXT:
      case SUSPEND_CONSTANTS.SUSPEND_WITH_CHARGES_UNDERSCORE_TXT:
        this.reasonCode = SUSPEND_CONSTANTS.SUSPEND_WITH_CHARGES;
        break;
      case SUSPEND_CONSTANTS.LOST_STOLEN_SUSPEND_TXT:
      case SUSPEND_CONSTANTS.LOST_STOLEN_SUSPEND_UNDERSCORE_TXT:
        this.reasonCode = SUSPEND_CONSTANTS.LOST_STOLEN_SUSPEND;
        break;
      case SUSPEND_CONSTANTS.EDUCATION_SUMMER_SUSPEND_TXT:
      case SUSPEND_CONSTANTS.EDUCATION_SUMMER_SUSPEND_UNDERSCORE_TXT:
        this.reasonCode = SUSPEND_CONSTANTS.EDUCATION_SUMMER_SUSPEND;
        break;
      case SUSPEND_CONSTANTS.IMPLEMENTATION_SUSPEND_TXT:
      case SUSPEND_CONSTANTS.IMPLEMENTATION_SUSPEND_UNDERSCORE_TXT:
        this.reasonCode = SUSPEND_CONSTANTS.IMPLEMENTATION_SUSPEND;
        break;
      case SUSPEND_CONSTANTS.MCSA_CONTRACTUAL_SUSPEND_TXT:
      case SUSPEND_CONSTANTS.MCSA_CONTRACTUAL_SUSPEND_UNDERSCORE_TXT:
        this.reasonCode = SUSPEND_CONSTANTS.MCSA_CONTRACTUAL_SUSPEND;
        break;
      case SUSPEND_CONSTANTS.SUNC_SUSPEND_TXT:
      case SUSPEND_CONSTANTS.SPECIAL_UNLIMITED_SUSPEND_UNDERSCORE_TXT:
        this.reasonCode = SUSPEND_CONSTANTS.SUNC_SUSPEND;
        break;
      case SUSPEND_CONSTANTS.RETENTION_SUSPEND_TXT:
      case SUSPEND_CONSTANTS.RETENTION_SUSPEND_UNDERSCORE_TXT:
        this.reasonCode = SUSPEND_CONSTANTS.RETENTION_SUSPEND;
        break;
      default:
        this.reasonCode = '';
    }
  }

  afterSuccesfullyUploaded(res: any, totalFailedRows: any): void {
    if (res != null) {
      this.uploadJsonData = res;
      ContentService.SetCache(BULK_UPLOAD.FAILEDROWS_LENGTH_TXT, totalFailedRows);
      this.logonData = JSON.parse(this._cacheSvc.getFromSessionStorage(MANAGE_LINE_CONST.AUTHENTICATION_INFO));
      if (typeof this.uploadJsonData !== COMMON_CONSTANTS.STRING_TXT && this.uploadJsonData.length > 0) {
        switch (this.bulkFlow) {
          case BULK_UPLOAD.CHANGE_PHONE_KEY:
            this.submitChangeNumberDataAfterUpload(res);
            break;
          case BULK_UPLOAD.SIM_SWAP_KEY:
            this.submitSimSwapDataAfterUpload();
            break;
          case BULK_UPLOAD.SUSPEND_KEY:
            this.submitSuspendDataAfterUpload();
            break;
          case BULK_UPLOAD.RESTORE_KEY:
            this.submitRestoreDataAfterUpload();
            break;
          case BULK_UPLOAD.TRANSFER_NUMBERS:
            this.submitTransferDataAfterUpload(res);
            break;
          case BULK_UPLOAD.LINE_IDENTIFIER:
            this.submitLineIdentifierDataAfterUpload(res);
            break;
          case BULK_UPLOAD.CANCEL_SUBSCRIBER:
          case BULK_UPLOAD.CHANGE_SERVICE:
          case BULK_UPLOAD.MANAGE_PAIRING:
          case BULK_UPLOAD.STRATEGIC_PORT_IN:
            this.submitDataAfterUpload();
            break;
        }
      } else if (typeof this.uploadJsonData === COMMON_CONSTANTS.STRING_TXT) {
        this.popuperror = this.uploadJsonData;
      }
    }
  }

  setCacheAndOpenModel(uploadJsonData: any) {
    this.ngbModalOptions = {
      backdrop: 'static',
      keyboard: false,
      container: '#am-container-custom',
      modalDialogClass: (this.bulkFlow === BULK_UPLOAD.LINE_IDENTIFIER && this.isUDFDormancyEnabled) ? 'popup-radius-udf' : ''
    };
    ContentService.SetCache(COMMON_CONSTANTS.LENGTH_TXT, uploadJsonData.length);
    ContentService.SetCache(BULK_UPLOAD.BULK_UPLOAD_REQUEST_KEY, uploadJsonData);
    this.manageLineService.close();
    this.chngBulkUploadModalRef = this.modalService.open(SubmitBulkUploadComponent, this.ngbModalOptions);
  }
  submitChangeNumberDataAfterUpload(records: any) {
    this.recordsWithErrors = records.filter((item) => item[BULK_UPLOAD.ERROR_KEY] !== undefined);
    this.recordsWithoutErrors = records.filter((item) => item[BULK_UPLOAD.ERROR_KEY] === undefined);
    const transferNumberArray = [];
    transferNumberArray.push(this.recordsWithoutErrors);
    transferNumberArray.push(this.recordsWithErrors);
    this.setCacheAndOpenModel(transferNumberArray);
  }

  submitSimSwapDataAfterUpload() {
    if (this.uploadJsonData != null) {
      this.recordsWithErrors = this.uploadJsonData.filter((item) => item[BULK_UPLOAD.ERROR_KEY] !== undefined);
      this.recordsWithoutErrors = this.uploadJsonData.filter((item) => item[BULK_UPLOAD.ERROR_KEY] === undefined);
      this.setHeaderRequestSimBulk(this.uploadJsonData);
      this.setCacheAndOpenModel(this.uploadJsonData);
    }
  }

  setHeaderRequestSimBulk(uploadJsonData) {
    this.authInfo = JSON.parse(this._cacheSvc.getFromSessionStorage(MANAGE_LINE_CONST.AUTHENTICATION_INFO));
    uploadJsonData.forEach((element) => {
      element.orgId = this.orgId;
      element.logonId = this.authInfo?.logonID ? this.authInfo.logonID : COMMON_CONSTANTS.LOGON_ID;
      element.email = this.authInfo?.logonEmail ? this.authInfo.logonEmail : COMMON_CONSTANTS.LOGON_ID;
    });
  }
  submitRestoreDataAfterUpload() {
    this.requests = [];
    if (this.uploadJsonData != null) {
      this.setCacheAndOpenModel(this.uploadJsonData);
    }
  }

  submitSuspendDataAfterUpload() {
    for (const jsonData of this.uploadJsonData) {
      this.mapReasons(jsonData.Suspend_reason);
      const temp1: any = {};
      temp1.orgId = this.orgId;
      temp1.msisdn = jsonData ? jsonData.PhoneNumber : '';
      temp1.reasonCode = this.reasonCode;
      temp1.suspendStartDate = jsonData ? jsonData.Suspend_start_date : '';
      temp1.restoreDate = jsonData ? jsonData.Suspend_end_date : '';
      temp1.extendContract = COMMON_CONSTANTS.TRUE_TXT;
      temp1.logonId = this.logonData ? this.logonData.logonID : '';
      temp1.email = this.logonData ? this.logonData.logonEmail : '';
      temp1.dealerCode = this.logonData ? this.logonData.dealerCode : '';
      temp1.validatorType = jsonData ? jsonData[BULK_UPLOAD.BULK_SUSPEND_APPROVER_TXT] : '';
      this.requests.push(temp1);
    }
    const temp: any = {};
    temp.targetServiceName = BULK_UPLOAD.SUSPEND_SERVICE_TXT;
    temp.requests = this.requests;
    this.requests = [];
    this.requestBody = temp;
    this.ngbModalOptions = {
      backdrop: 'static',
      keyboard: false,
      container: '#am-container-custom',
    };
    ContentService.SetCache(BULK_UPLOAD.BULK_UPLOAD_REQUEST_KEY, this.requestBody);
    this.manageLineService.close();
    this.chngBulkUploadModalRef = this.modalService.open(SubmitBulkUploadComponent, this.ngbModalOptions);

  }

  getTemplateType() {
    if (this.templateType != null) {
      switch (this.bulkFlow) {
        case BULK_UPLOAD.CHANGE_PHONE_KEY:
          this.getTemplateForChangePhoneKey();
          break;
        case BULK_UPLOAD.SIM_SWAP_KEY:
          this.getTemplateForSimSwap();
          break;
        case BULK_UPLOAD.SUSPEND_KEY:
          this.getTemplateForSuspendKey();
          break;
        case BULK_UPLOAD.RESTORE_KEY:
          this.getTemplateForRestore();
          break;
        case BULK_UPLOAD.TRANSFER_NUMBERS:
          this.getTemplateForTransferNumer();
          break;
        case BULK_UPLOAD.LINE_IDENTIFIER:
          this.getTemplateForLineIdentifier();
          this.fileToBeDownloaded = (this.templateType === BULK_UPLOAD.XLSX_TXT) ?
            BULK_TEMPLATE_FILES.LINE_IDENTIFIERS : BULK_TEMPLATE_FILES.LINE_IDENTIFIERS_CSV;
          break;
        case BULK_UPLOAD.CANCEL_SUBSCRIBER:
          this.setFileToBeDownloaded(BULK_TEMPLATE_FILES.CANCEL_SUBSCRIBER, BULK_TEMPLATE_FILES.CANCEL_SUBSCRIBER_CSV);
          break;
        case BULK_UPLOAD.CHANGE_SERVICE:
          this.setFileToBeDownloaded(BULK_TEMPLATE_FILES.CHANGE_SERVICE, BULK_TEMPLATE_FILES.CHANGE_SERVICE_CSV);
          break;
        case BULK_UPLOAD.MANAGE_PAIRING:
          this.setFileToBeDownloaded(BULK_TEMPLATE_FILES.MANAGE_PAIRING_XLSX, BULK_TEMPLATE_FILES.MANAGE_PAIRING_CSV);
          break;
        case BULK_UPLOAD.STRATEGIC_PORT_IN:
          this.setFileToBeDownloaded(BULK_TEMPLATE_FILES.STRATEGIC_PORT_IN_XLSX, BULK_TEMPLATE_FILES.STRATEGIC_PORT_IN_CSV);
          break;
        case BULK_UPLOAD.TPOP_KEY:
          this.fileToBeDownloaded = BULK_TEMPLATE_FILES.TPOP_XLSX;
          break;
      }
    }
  }
  getTemplateForChangePhoneKey() {
    this.fileToBeDownloaded = (this.templateType === BULK_UPLOAD.XLSX_TXT) ?
      BULK_TEMPLATE_FILES.CHANGE_NUMBER : BULK_TEMPLATE_FILES.CHANGE_NUMBER_CSV;
  }
  getTemplateForSimSwap(){
    if(this.eSimEnabled){
      this.fileToBeDownloaded = (this.templateType === BULK_UPLOAD.XLSX_TXT) ?
      BULK_TEMPLATE_FILES.ESIM_CHANGE : BULK_TEMPLATE_FILES.ESIM_CHANGE_CSV;
    }else{
      this.fileToBeDownloaded = (this.templateType === BULK_UPLOAD.XLSX_TXT) ?
      BULK_TEMPLATE_FILES.SIM_CHANGE : BULK_TEMPLATE_FILES.SIM_CHANGE_CSV;
    }
  }
  getTemplateForSuspendKey() {
    this.fileToBeDownloaded = (this.templateType === BULK_UPLOAD.XLSX_TXT) ?
      BULK_TEMPLATE_FILES.SUSPEND : BULK_TEMPLATE_FILES.SUSPEND_CSV;
    if (this.templateType === BULK_UPLOAD.XLSX_TXT && (!this.isOkta)) {
      this.fileToBeDownloaded = BULK_TEMPLATE_FILES.SUSPEND_IAM
    }
    if (this.templateType === BULK_UPLOAD.XLSX_TXT && this.isOkta && this.accountType === SUSPEND_CONSTANTS.ACCOUNT_TYPE_G) {
      this.fileToBeDownloaded = BULK_TEMPLATE_FILES.SUSPEND_ACCOUNT_TYPE_G
    }
  }
  getTemplateForRestore() {
    this.fileToBeDownloaded = (this.templateType === BULK_UPLOAD.XLSX_TXT) ?
      BULK_TEMPLATE_FILES.RESTORE : BULK_TEMPLATE_FILES.RESTORE_CSV;
  }
  getTemplateForTransferNumer() {
    this.fileToBeDownloaded = (this.templateType === BULK_UPLOAD.XLSX_TXT) ?
      BULK_TEMPLATE_FILES.TRANSFER_NUMBERS : BULK_TEMPLATE_FILES.TRANSFER_NUMBERS_CSV;
  }
  getTemplateForLineIdentifier() {
    this.fileToBeDownloaded = (this.templateType === BULK_UPLOAD.XLSX_TXT) ?
      BULK_TEMPLATE_FILES.LINE_IDENTIFIERS : BULK_TEMPLATE_FILES.LINE_IDENTIFIERS_CSV;
  }

  setFileToBeDownloaded(xlsxTemplateType, csvTemplateType) {
    this.fileToBeDownloaded = (this.templateType === BULK_UPLOAD.XLSX_TXT) ?
    xlsxTemplateType : csvTemplateType;
  }

  setSubHeader(val) {
    if (val != null) {
      this.subheader = val;
    }
  }

  getSubHeader() {
    this.subheader = '';
    this.voluntarySusp = HttpCacheService.GetCache(MANAGE_LINE_CONST.IS_VOLUNTARY_SUSP);
    if (this.authoringContentData?.bulkFlow) {
      if (!this.bulkOrInlineFlow) {
        switch (this.bulkFlow) {
          case BULK_UPLOAD.CHANGE_PHONE_KEY:
            this.setSubHeader(this.authoringContentData.bulkFlow.bulkUploadChangPhoneSubheaderTxt);
            break;
          case BULK_UPLOAD.SIM_SWAP_KEY:
            this.setSubHeader(this.authoringContentData.bulkFlow.bulkUploadSimSwapSubheaderTxt);
            break;
          case BULK_UPLOAD.SUSPEND_KEY:
            this.setSubHeader(this.authoringContentData.bulkFlow.bulkUploadSuspendSubheaderTxt);
            break;
          case BULK_UPLOAD.RESTORE_KEY:
            if (this.voluntarySusp === false) {
              this.setSubHeader(this.authoringContentData.bulkFlow.bulkUploadRestoreSubheaderTxt);
              break;
            }
            this.setSubHeader(this.authoringContentData.bulkFlow.suspendBulkUploadRestoreSubheaderTxt);
            break;
          case BULK_UPLOAD.LINE_IDENTIFIER:
            if (this.isUDFDormancyEnabled) {
              this.setSubHeader(this.authoringContentData.bulkFlow.udfBulkInlineflowSubheaderTxt);
            }
            else {
              this.setSubHeader(this.authoringContentData.bulkFlow.bulkInlineflowSubheaderTxt);
            }
            break;
          case BULK_UPLOAD.CANCEL_SUBSCRIBER:
            this.title = this.authoringContentData.bulkFlow.bulkUploadCancelSubscriberTitleTxt;
            break;
          case BULK_UPLOAD.CHANGE_SERVICE:
            this.title = this.authoringContentData.bulkFlow.bulkUploadChangeServiceTitleTxt;
            break;
          case BULK_UPLOAD.MANAGE_PAIRING:
            this.title = this.authoringContentData.managePairing.managePairingCTA;
            break;
          case BULK_UPLOAD.STRATEGIC_PORT_IN:
            this.title = this.authoringContentData.bulkFlow.headingBulkStrategicPortIn;
            break;
          case BULK_UPLOAD.TPOP_KEY:
            this.title = this.authoringContentData.bulkFlow.headingBulkTpop;
            break;
        }
      } else {
        this.subheader = this.authoringContentData?.bulkFlow?.bulkUploadRestoreSubheaderTxt ?
          this.authoringContentData.bulkFlow.bulkInlineflowSubheaderTxt : this.subheader;
      }
    }
  }

  setTitle(val) {
    if (val != null) {
      this.title = val;
    }
  }

  getTitleAndWorkSheetName() {
    this.title = '';
    if (this.authoringContentData?.bulkFlow != null) {
      switch (this.bulkFlow) {
        case BULK_UPLOAD.CHANGE_PHONE_KEY:
          this.setTitle(this.authoringContentData.bulkFlow.bulkUploadChangPhoneTitleTxt);
          this.worksheetname = BULK_UPLOAD.BULK_TEMPLATE_CHANGEMSISDN;
          break;
        case BULK_UPLOAD.SIM_SWAP_KEY:
          this.setTitle(this.authoringContentData.bulkFlow.bulkUploadSimSwapTitleTxt);
          if(this.eSimEnabled){
            this.worksheetname = BULK_UPLOAD.BULK_TEMPLATE_ESIM_SWAP;
          }else{
            this.worksheetname = BULK_UPLOAD.BULK_TEMPLATE_SIM_SWAP;
          }
          break;
        case BULK_UPLOAD.SUSPEND_KEY:
          this.setTitle(this.authoringContentData.bulkFlow.bulkUploadSuspendTitleTxt);
          this.worksheetname = BULK_UPLOAD.BULK_TEMPLATE_SUSPEND;
          break;
        case BULK_UPLOAD.RESTORE_KEY:
          this.setTitle(this.authoringContentData.bulkFlow.bulkUploadRestoreTitleTxt);
          this.worksheetname = BULK_UPLOAD.BULK_TEMPLATE_RESTORE;
          break;
        case BULK_UPLOAD.TRANSFER_NUMBERS:
          this.setTitle(this.authoringContentData.bulkFlow.bulkUploadTransferNumberTitleTxt);
          this.worksheetname = BULK_UPLOAD.BULK_TEMPLATE_TRANSFERNUMBER;
          break;
        case BULK_UPLOAD.LINE_IDENTIFIER:
          this.setTitle(this.authoringContentData.bulkFlow.bulkUploadLineIdentifierTitleTxt);
          this.worksheetname = BULK_UPLOAD.BULK_TEMPLATE_LINEIDENTIFIER;
          break;
        case BULK_UPLOAD.MANAGE_PAIRING:
          this.setTitle(this.authoringContentData.managePairing.managePairingCTA);
          this.worksheetname = BULK_UPLOAD.BULK_TEMPLATE_MANAGEPAIRING;
          break;
        case BULK_UPLOAD.STRATEGIC_PORT_IN:
          this.setTitle(this.authoringContentData.strategicPortIn.strategicPortInCTA);
          this.worksheetname = BULK_UPLOAD.BULK_TEMPLATE_STRATEGIC_PORT_IN;
          break;
        case BULK_UPLOAD.TPOP_KEY:
          this.setTitle(this.authoringContentData.bulkFlow.headingBulkTpop);
          this.worksheetname = BULK_UPLOAD.BULK_TEMPLATE_TPOP;
          break;  
      }
    }
  }

  validateSuspendSheet(sheetData) {
    // tslint:disable-next-line: no-angle-bracket-type-assertion
    const colDefs = <ColumnDefinitionDateStr[]>suspendColumnsDefinition;
    let count = 0;
    let totalInvalidRows = 0;
    let totalCount = 0;
    let suspendReasonValue = '';

    sheetData.forEach((data) => {
      if (count >= 0) {
        const tempKeys = BULK_UPLOAD.SUSPEND_OBJECT_KEYS;
        totalCount = 0;
        for (let i = 0; i < tempKeys.length; i++) {
          totalCount += count;
          let flag = false;
          if (tempKeys[i] === BULK_UPLOAD.BULK_PHONE_NUMBER_TXT) {
            data[tempKeys[i]] = data[tempKeys[i]].toString().replace(/[^0-9]/g, '');
            const phoneValue = data[tempKeys[i]];
            const colDef = colDefs.find((col) => col.headerName === BULK_UPLOAD.BULK_PHONE_NUMBER_TXT);
            count = this.errorCheck(phoneValue, colDef);
            flag = true;
            if (count === 1) {
              count = -1;
              return -1;
            }
          }
          if (tempKeys[i] === BULK_UPLOAD.BULK_SUSPEND_REASON_TXT) {
            suspendReasonValue = data[tempKeys[i]];
            const colDef = colDefs.find((col) => col.headerName === BULK_UPLOAD.BULK_SUSPEND_REASON_TXT);
            count = this.errorCheck(suspendReasonValue, colDef);
            flag = true;
            if (count === 1) {
              count = -1;
              return -1;
            }
          }

          if (tempKeys[i] === BULK_UPLOAD.BULK_SUSPEND_APPROVER_TXT) {
            if (suspendReasonValue === BULK_UPLOAD.SUSPNDREASN_SEASONAL_TXT || suspendReasonValue === BULK_UPLOAD.SUSPNDREASN_LOST_TXT) {
              const phoneValue = data[tempKeys[i]];
              const colDef = colDefs.find((col) => col.dataType === COMMON_CONSTANTS.STRING_TXT);
              count = this.errorCheck(phoneValue, colDef);
            } else if (suspendReasonValue === BULK_UPLOAD.SUSPNDREASN_TEMP_TXT) {
              const phoneValue = data[tempKeys[i]];
              const colDef = colDefs.find((col) => col.dataType === BULK_UPLOAD.TEMPSUSPND_RANGE_TXT);
              count = this.errorCheck(phoneValue, colDef);
              // tslint:disable-next-line:max-line-length
            } else if (suspendReasonValue === BULK_UPLOAD.SUSPNDREASN_RESELLWITHOUT_TXT || suspendReasonValue === BULK_UPLOAD.SUSPNDREASN_RESELLWITH_TXT) {
              const phoneValue = data[tempKeys[i]];
              const colDef = colDefs.find((col) => col.dataType === BULK_UPLOAD.RESELL_RANGE_TXT);
              count = this.errorCheck(phoneValue, colDef);
            }
            flag = true;
            if (count === 1) {
              count = -1;
              return -1;
            }
          }
          if (tempKeys[i] === BULK_UPLOAD.BULK_SUSPEND_STARTDATE_TXT) {
            const phoneValue = data[tempKeys[i]];
            let colDef = colDefs.find((col) => col.headerName === BULK_UPLOAD.BULK_SUSPEND_STARTDATE_TXT);
            if (data[BULK_UPLOAD.BULK_SUSPEND_REASON_TXT] == SUSPEND_CONSTANTS.RETENTION_SUSPEND_UNDERSCORE_TXT ||
              data[BULK_UPLOAD.BULK_SUSPEND_REASON_TXT] == SUSPEND_CONSTANTS.RETENTION_SUSPEND_TXT) {
              colDef = colDefs.find((col) => col.headerName === BULK_UPLOAD.COL_HEADER_START_DATE_TODAY);
            }
             if(data[BULK_UPLOAD.BULK_SUSPEND_REASON_TXT] != SUSPEND_CONSTANTS.LOST_STOLEN_SUSPEND_UNDERSCORE_TXT
             && data[BULK_UPLOAD.BULK_SUSPEND_REASON_TXT] != SUSPEND_CONSTANTS.RETENTION_SUSPEND_UNDERSCORE_TXT){
                count = this.errorCheck(phoneValue, colDef);
            }
            flag = true;
            if (count === 1) {
              count = -1;
              return -1;
            }
          }

          if (tempKeys[i] === BULK_UPLOAD.BULK_SUSPEND_ENDDATE_TXT) {
            if (data[tempKeys[i]] < data[tempKeys[i - 1]]) {
              this.popuperror = this.authoringContentData?.bulkFlow?.headerIsnotCorrect ? this.authoringContentData.bulkFlow.headerIsnotCorrect : '';
            } else {
              const notRETNSelected = data[BULK_UPLOAD.BULK_SUSPEND_REASON_TXT] != SUSPEND_CONSTANTS.RETENTION_SUSPEND_UNDERSCORE_TXT && data[BULK_UPLOAD.BULK_SUSPEND_REASON_TXT] != SUSPEND_CONSTANTS.RETENTION_SUSPEND_TXT;
              if (notRETNSelected && data[BULK_UPLOAD.BULK_SUSPEND_REASON_TXT] != SUSPEND_CONSTANTS.LOST_STOLEN_SUSPEND_UNDERSCORE_TXT && data[BULK_UPLOAD.BULK_SUSPEND_REASON_TXT] != SUSPEND_CONSTANTS.LOST_STOLEN_SUSPEND_TXT) {
                const phoneValue = data[tempKeys[i]];
                const colDef = colDefs.find((col) => col.headerName === BULK_UPLOAD.BULK_SUSPEND_ENDDATE_TXT);
                count = this.errorCheck(phoneValue, colDef);
              }
            }
            flag = true;
            if (count === 1) {
              count = -1;
              return -1;
            }
          }

          if (!flag) {
            count = -1;
            return -1;
          }
        }
        totalInvalidRows = totalCount > 0 ? totalInvalidRows + 1 : totalInvalidRows;
        if (totalCount === 0) {
          this.validUploadData.push(data);
        }
      } else {
        totalInvalidRows = count;
      }

    });
    return totalInvalidRows;

  }

  errorCheck(value, colDef) {
    switch (colDef.dataType) {
      case BULK_UPLOAD.BAN:
        if (value != null && value.toString().length === 9 && !isNaN(+value)) {
          return 0;
        }
        return 1;
      case BULK_UPLOAD.NUMBER:
        if (value != null && value.toString().length === 10 && !isNaN(+value)) {
          return 0;
        }
        return 1;
      case 'range':
      case BULK_UPLOAD.TEMPSUSPND_RANGE_TXT:
      case BULK_UPLOAD.RESELL_RANGE_TXT:
        // tslint:disable-next-line: no-angle-bracket-type-assertion
        const rangeValues = <string[]>colDef.range;
        if (value != null && rangeValues.indexOf(value) > -1) {
          return 0;
        }
        return 1;
      case BULK_UPLOAD.COL_DEF_DATE_TODAY:
        if (Date.parse(colDef.minDate) == Date.parse(value)) {
          return 0;
        }
        return 1;
      case BULK_UPLOAD.DATE:
        if (Date.parse(colDef.minDate) <= Date.parse(value)) {
          return 0;
        }
        return 1;
      default: return 0;
    }
  }

  makingErrorMessageForRestore(sheetData: any): boolean {
    // tslint:disable-next-line: no-angle-bracket-type-assertion
    const colDefs = <ColumnDefinition[]>restoreColumnsDefinition;
    if (colDefs != null && sheetData?.length > 0) {
      for (let j = 0; j < 1; j++) {
        const data = sheetData[j];
        if (data != null) {
          const tempKeys = Object.keys(data);
          if (tempKeys != null) {
            for (let i = 0; i < tempKeys.length; i++) {
              if (tempKeys[i] !== BULK_UPLOAD.BULK_PHONE_NUMBER_TXT && i === 0) {
                this.showHeaderErrorMsg();
                return false;
              }
              if (tempKeys[i] !== BULK_UPLOAD.BULK_UPLOAD_RESTORE_DATE && i === 1) {
                this.showHeaderErrorMsg();
                return false;
              }
            }
          }
        }
      }
    }
    return true;
  }

  validateRestoreSheet(sheetData) {
    // tslint:disable-next-line: no-angle-bracket-type-assertion
    const colDefs = <ColumnDefinition[]>restoreColumnsDefinition;
    let count = 0;
    let totalInvalidRows = 0;
    if (colDefs != null && sheetData?.length > 0) {
      sheetData.forEach((data) => {
        if (data != null) {
          if (count >= 0) {
            totalInvalidRows += count;
            const tempKeys = Object.keys(data);
            if (tempKeys != null) {
              for (let i = 0; i < tempKeys.length; i++) {
                if (tempKeys[i] === BULK_UPLOAD.BULK_PHONE_NUMBER_TXT && i === 0) {
                  data[tempKeys[i]] = data[tempKeys[i]].toString().replace(/[^0-9]/g, '');
                  const phoneValue = data[tempKeys[i]];
                  const colDef = colDefs.find((col) => col.headerName === BULK_UPLOAD.BULK_PHONE_NUMBER_TXT);
                  count = this.restoreErrorCheck(phoneValue, colDef);
                  if (count === 1) {
                    count = -1;
                    return -1;
                  }
                } else if (i === 0) {
                  count = -1;
                  return count;
                }
                if (tempKeys[i] === BULK_UPLOAD.BULK_UPLOAD_RESTORE_DATE && i === 1) {
                  const phoneValue = data[tempKeys[i]];
                  const colDef = colDefs.find((col) => col.headerName === BULK_UPLOAD.BULK_UPLOAD_RESTORE_DATE);
                  count = this.restoreErrorCheck(phoneValue, colDef);
                } else if (i === 1) {
                  count = -1;
                  return count;
                }
              }
            }
          } else {
            totalInvalidRows = count;
          }
        }
      });
    } else {
      return -1;
    }
    return totalInvalidRows;
  }

  restoreErrorCheck(value, colDef) {
    if (value != null && colDef != null) {
      switch (colDef.dataType) {
        case BULK_UPLOAD.NUMBER:
          if (value.toString().length === 10 && !isNaN(+value)) {
            this.restoreMsgFlag = true;
            return 0;
          }
          this.restoreMsgFlag = false;
          this.popuperror = this.authoringContentData?.bulkFlow?.errorWhileUploadingTxt ?
            this.authoringContentData.bulkFlow.errorWhileUploadingTxt : '';
          return 1;
        case BULK_UPLOAD.DATE:
          const date = new Date(value);
          if (date >= new Date()) {
            return 0;
          }
          return 1;
        default: return 0;
      }
    }
  }

  validateChangeNumberSheet(sheetData) {
    // tslint:disable-next-line: no-angle-bracket-type-assertion
    const colDefs = <ColumnDefinition[]>changeNumbersColumnsDefinition;
    let count = VALUE.ZERO;
    let errorCountPerRow = VALUE.ZERO;
    let issuesFound = VALUE.ZERO;
    let validatePhoneNumber = false;
    const invalidHeaderFormat = false;
    sheetData = _.forEach(sheetData, (item) => {

      item.PhoneNumber = _.get(item, BULK_UPLOAD.BULK_PHONE_NUMBER_TXT, '');
      if (_.isEmpty(item.PhoneNumber.toString())) {
        validatePhoneNumber = true;
      }
      item.PhoneNumber = item.PhoneNumber.toString().replace(/[^0-9]/g, '');
      item.Preferred_Area_Code = _.get(item, BULK_UPLOAD.PREFERRED_AREA_CODE, '');
      item.Reason_For_Change = _.get(item, BULK_UPLOAD.BULK_SIMSWAP_REASON_FOR_CHANGE_Txt, '');
      item.Reason_For_Change = item.Reason_For_Change.replace(/[^ A-Z a-z /]/g, '');
    });

    if (invalidHeaderFormat) {
      this.showHeaderErrorMsg();
      this.uploadProgressShow = false;
      return;
    }

    if (validatePhoneNumber) {
      this.showPhoneErrorMsg();
      return;
    }

    if (colDefs != null && sheetData?.length > VALUE.ZERO) {
      sheetData.forEach((data) => {
        if (data != null) {
          if (count >= VALUE.ZERO) {
            issuesFound += count;
            const tempKeys = Object.keys(data);
            if (tempKeys != null) {
              for (const tempKey of tempKeys) {
                const colDef = colDefs.find((col) => col.headerName === tempKey);
                const value = data[tempKey];
                switch (tempKey) {
                  case BULK_UPLOAD.BULK_PHONE_NUMBER_TXT:
                    if (value && value.toString().length === 10 && !isNaN(+value)) {
                      count = this.validationForChangeNumber(value, colDef);
                      if (count === VALUE.ONE) {
                        errorCountPerRow += count;
                        this.addError(data, BULK_UPLOAD.INVALID_ACCOUNT_NUMBER_ERR_KEY, BULK_UPLOAD.EXCEL_ERROR_MSG.INVALID_PHONE_NUMBER_TXT);
                      }
                    } else {
                      count = VALUE.ONE;
                      errorCountPerRow += count;
                      this.addError(data, BULK_UPLOAD.MISSING_ACCOUNT_NUMBER_ERR_KEY, BULK_UPLOAD.EXCEL_ERROR_MSG.MISSING_PHONE_NUMBER_TXT);
                    }
                    break;
                  case BULK_UPLOAD.PREFERRED_AREA_CODE:
                    if (value && value.toString().length === 3 && !isNaN(+value)) {
                      count = this.validationForChangeNumber(value, colDef);
                      if (count === VALUE.ONE) {
                        errorCountPerRow += count;
                        this.addError(data, BULK_UPLOAD.INVALID_ACCOUNT_NUMBER_ERR_KEY, BULK_UPLOAD.EXCEL_ERROR_MSG.INVALID_PREFERRED_AREA_CODE);
                      }
                    } else {
                      count = VALUE.ONE;
                      errorCountPerRow += count;
                      this.addError(data, BULK_UPLOAD.MISSING_ACCOUNT_NUMBER_ERR_KEY, BULK_UPLOAD.EXCEL_ERROR_MSG.MISSING_PREFERRED_AREA_CODE);
                    }
                    break;
                  case BULK_UPLOAD.BULK_SIMSWAP_REASON_FOR_CHANGE_Txt:
                    if (value && this.validateReasonForChangeNumber(value)) {
                      count = this.validationForChangeNumber(value, colDef);
                      if (count === VALUE.ONE) {
                        errorCountPerRow += count;
                        this.addError(data, BULK_UPLOAD.INVALID_ACCOUNT_NUMBER_ERR_KEY, BULK_UPLOAD.EXCEL_ERROR_MSG.INVALID_BULK_SIMSWAP_REASON_FOR_CHANGE);
                      }
                    } else {
                      count = VALUE.ONE;
                      errorCountPerRow += count;
                      this.addError(data, BULK_UPLOAD.MISSING_ACCOUNT_NUMBER_ERR_KEY, BULK_UPLOAD.EXCEL_ERROR_MSG.MISSING_BULK_SIMSWAP_REASON_FOR_CHANGE);
                    }
                    break;
                }
              }
            }
            issuesFound = errorCountPerRow;
          }
        }
      });
    } else {
      return VALUE.MINUS_ONE;
    }
    this.transformInlineErrorObject = Object.assign([], sheetData);
    return issuesFound;
  }
  validateReasonForChangeNumber(value) {
    const validate = _.find(MSISDN_CHANGE_REASONS, { description: value });
    return !_.isEmpty(validate);
  }

  addError(data, errorKey, errorMsg, isSimSwap?) {
    data[errorKey] = errorMsg;
    if (!(BULK_UPLOAD.ERROR_KEY in data)) {
      if(this.eSimEnabled && isSimSwap){
        this.createNewErrorNode(errorMsg,data);
      }else{
        data[BULK_UPLOAD.ERROR_KEY] = errorMsg;
      }
    } else {
      if(this.eSimEnabled && isSimSwap){
        this.updateExistingErrorNode(errorMsg,data);
      }else{
        data[BULK_UPLOAD.ERROR_KEY] += COMMON_CONSTANTS.SYMBOLS.SPACE_SLASH + errorMsg;
      }
    }
    return data;
  }
  createNewErrorNode(errorMsg,data){
    /** show missing EID msg when NewSim is also empty as both are not mandatory
     * show missing NewSim msg when EID is also empty as both are not mandatory
     * show delete NewSim or delete EID msg when both are available
     */
    if(errorMsg === BULK_UPLOAD.EXCEL_ERROR_MSG.MISSING_BULK_SIMSWAP_EID && data[BULK_UPLOAD.BULK_ESIMSWAP_NEWSIM_Txt] === COMMON_CONSTANTS.STRING_EMPTY){
      data[BULK_UPLOAD.ERROR_KEY] = errorMsg;
    }else if(errorMsg === BULK_UPLOAD.EXCEL_ERROR_MSG.MISSING_BULK_SIMSWAP_NEWSIM && data[BULK_UPLOAD.BULK_SIMSWAP_EID_Txt] === COMMON_CONSTANTS.STRING_EMPTY){
      this.assignErrorKey(data,errorMsg);
    }else if(errorMsg === BULK_UPLOAD.EXCEL_ERROR_MSG.DELETE_EID_NEWSIM){
      this.assignErrorKey(data,errorMsg);
    }else if(errorMsg === BULK_UPLOAD.EXCEL_ERROR_MSG.MISSING_BULK_SIMSWAP_REASON_FOR_CHANGE){
      data[BULK_UPLOAD.ERROR_KEY] = errorMsg;
    }
  }
  updateExistingErrorNode(errorMsg,data){
    /** show missing EID msg when NewSim is also empty as both are not mandatory
     * show missing NewSim msg when EID is also empty as both are not mandatory
     * show delete NewSim or delete EID msg when both are available
     */
    if(errorMsg === BULK_UPLOAD.EXCEL_ERROR_MSG.MISSING_BULK_SIMSWAP_EID && data[BULK_UPLOAD.BULK_ESIMSWAP_NEWSIM_Txt] === COMMON_CONSTANTS.STRING_EMPTY){
      data[BULK_UPLOAD.ERROR_KEY] += COMMON_CONSTANTS.SYMBOLS.SPACE_SLASH + errorMsg;
    }else if(errorMsg === BULK_UPLOAD.EXCEL_ERROR_MSG.MISSING_BULK_SIMSWAP_NEWSIM && data[BULK_UPLOAD.BULK_SIMSWAP_EID_Txt] === COMMON_CONSTANTS.STRING_EMPTY){
      data[BULK_UPLOAD.ERROR_KEY] += COMMON_CONSTANTS.SYMBOLS.SPACE_SLASH + errorMsg;
    }else if(errorMsg === BULK_UPLOAD.EXCEL_ERROR_MSG.DELETE_EID_NEWSIM){
      this.assignErrorKey(data,errorMsg);
    }else if(errorMsg === BULK_UPLOAD.EXCEL_ERROR_MSG.MISSING_BULK_SIMSWAP_REASON_FOR_CHANGE){
      data[BULK_UPLOAD.ERROR_KEY] += COMMON_CONSTANTS.SYMBOLS.SPACE_SLASH + errorMsg;
    }
  }
  assignErrorKey(data,errorMsg){
    data[BULK_UPLOAD.ERROR_KEY] = errorMsg;
  }

  validateSimSwapSheet(sheetData) {
    // tslint:disable-next-line: no-angle-bracket-type-assertion
    const colDefs = this.eSimEnabled ? <ColumnDefinition[]>eSimSwapColumnsDefinition : <ColumnDefinition[]>simSwapColumnsDefinition;
    let count = VALUE.ZERO;
    let totalInvalidRows = VALUE.ZERO;
    // tslint:disable-next-line:no-unused-variable
    // @ts-ignore
    let errorCountPerRow = VALUE.ZERO;
    if (colDefs && sheetData?.length > 0) {
      sheetData.forEach((data) => {
        let prevPhoneValCount = VALUE.ZERO;
        let prevOldSimCount = VALUE.ZERO;
        if (data != null) {
          if (count >= 0) {
            totalInvalidRows += count;
            const tempKeys = Object.keys(data);
            if (tempKeys != null) {
              // tslint:disable-next-line: prefer-for-of
              for (const tempKey of tempKeys) {
                let colDef;
                let errorMsg;
                let errorKey;
                switch (tempKey) {
                  case BULK_UPLOAD.BULK_PHONE_NUMBER_TXT :
                    data[tempKey] = data[tempKey].toString().replace(/[^0-9]/g, '');
                    const phoneValue = data[tempKey];
                    colDef = colDefs.find((col) => col.headerName === BULK_UPLOAD.BULK_PHONE_NUMBER_TXT);
                    if (phoneValue?.toString().length === 10) {
                      count = this.validationForChangeNumber(phoneValue, colDef);
                      prevPhoneValCount = count;
                      errorMsg = BULK_UPLOAD.EXCEL_ERROR_MSG.INVALID_PHONE_NUMBER_TXT;
                      errorKey = BULK_UPLOAD.INVALID_ACCOUNT_NUMBER_ERR_KEY;
                    } else {
                      count = VALUE.ONE;
                      errorMsg = BULK_UPLOAD.EXCEL_ERROR_MSG.MISSING_PHONE_NUMBER_TXT;
                      errorKey = BULK_UPLOAD.MISSING_ACCOUNT_NUMBER_ERR_KEY;
                    }
                    if (count === VALUE.ONE && prevPhoneValCount !== VALUE.ZERO) {
                      errorCountPerRow += count;
                      data = this.addError(data, errorKey, errorMsg, true);
                    }
                    break;
                  case BULK_UPLOAD.BULK_SIMSWAP_OLDSIM_Txt:
                    const oldSimValue = data[tempKey];
                    colDef = colDefs.find((col) => col.headerName === BULK_UPLOAD.BULK_SIMSWAP_OLDSIM_Txt);
                    if (oldSimValue && (this.regex19.test(oldSimValue) || this.regex20.test(oldSimValue))) {
                      count = this.simSwapErrorCheck(oldSimValue, colDef);
                      prevOldSimCount = count;
                      errorMsg = BULK_UPLOAD.EXCEL_ERROR_MSG.INVALID_BULK_SIMSWAP_OLDSIM;
                      errorKey = BULK_UPLOAD.INVALID_ACCOUNT_NUMBER_ERR_KEY;
                    } else {
                      count = VALUE.ONE;
                      errorMsg = BULK_UPLOAD.EXCEL_ERROR_MSG.MISSING_BULK_SIMSWAP_OLDSIM;
                      errorKey = BULK_UPLOAD.MISSING_ACCOUNT_NUMBER_ERR_KEY;
                    }
                    if (count === VALUE.ONE && prevOldSimCount !== VALUE.ZERO) {
                      errorCountPerRow += count;
                      data = this.addError(data, errorKey, errorMsg, true);
                    }
                    break;
                  case BULK_UPLOAD.BULK_SIMSWAP_EID_Txt:
                    this.validateSimSwapSheetForEID(data,tempKey,colDefs,count);
                    break;
                  case BULK_UPLOAD.BULK_SIMSWAP_NEWSIM_Txt:
                  case BULK_UPLOAD.BULK_ESIMSWAP_NEWSIM_Txt:
                    this.validateSimSwapSheetForNewSim(data,tempKey,colDefs,count);
                    break;
                  case BULK_UPLOAD.BULK_SIMSWAP_REASON_FOR_CHANGE_Txt:
                    const reasonValue = data[tempKey];
                    colDef = colDefs.find((col) => col.headerName === BULK_UPLOAD.BULK_SIMSWAP_REASON_FOR_CHANGE_Txt);
                    if (reasonValue && this.validateReasonForSimSwap(reasonValue)) {
                      count = this.simSwapErrorCheck(reasonValue, colDef);
                      errorMsg = BULK_UPLOAD.EXCEL_ERROR_MSG.INVALID_BULK_SIMSWAP_REASON_FOR_CHANGE;
                      errorKey = BULK_UPLOAD.INVALID_ACCOUNT_NUMBER_ERR_KEY;
                    } else {
                      count = VALUE.ONE;
                      errorMsg = BULK_UPLOAD.EXCEL_ERROR_MSG.MISSING_BULK_SIMSWAP_REASON_FOR_CHANGE;
                      errorKey = BULK_UPLOAD.MISSING_ACCOUNT_NUMBER_ERR_KEY;
                    }
                    if (count === VALUE.ONE) {
                      errorCountPerRow += count;
                      data = this.addError(data, errorKey, errorMsg, true);
                    }
                    break;
                }
              }
            } else {
              totalInvalidRows = count;
            }
          }
        }
      });
    } else {
      return -1;
    }
    return totalInvalidRows;
  }
  validateSimSwapSheetForEID(data,tempKey,colDefs,count){
    let colDef;
    let errorMsg;
    let errorKey;
    const eidValue = data[tempKey];
    colDef = colDefs.find((col) => col.headerName === BULK_UPLOAD.BULK_SIMSWAP_EID_Txt);
    if (eidValue && this.regex32.test(eidValue)) {
      count = this.simSwapErrorCheck(eidValue, colDef);
      errorMsg = BULK_UPLOAD.EXCEL_ERROR_MSG.INVALID_BULK_SIMSWAP_EID;
      errorKey = BULK_UPLOAD.INVALID_ACCOUNT_NUMBER_ERR_KEY;
    } else {
      count = VALUE.ONE;
      errorMsg = BULK_UPLOAD.EXCEL_ERROR_MSG.MISSING_BULK_SIMSWAP_EID;
      errorKey = BULK_UPLOAD.MISSING_ACCOUNT_NUMBER_ERR_KEY;
    }
    if (count === VALUE.ONE) {
      this.addError(data, errorKey, errorMsg, true);
    }
  }
  validateSimSwapSheetForNewSim(data,tempKey,colDefs,count){
    let colDef;
    let errorMsg;
    let errorKey;
    const newSimValue = data[tempKey];
    colDef = colDefs.find((col) => col.headerName === BULK_UPLOAD.BULK_SIMSWAP_NEWSIM_Txt
    || col.headerName === BULK_UPLOAD.BULK_ESIMSWAP_NEWSIM_Txt);
    if (
    (!this.eSimEnabled && newSimValue && (this.regex19.test(newSimValue) || this.regex20.test(newSimValue)))
    || (this.eSimEnabled && newSimValue && (this.regex19.test(newSimValue) || this.regex20.test(newSimValue))
    && newSimValue !== data[BULK_UPLOAD.BULK_SIMSWAP_OLDSIM_Txt])
    ) {
      count = this.simSwapErrorCheck(newSimValue, colDef);
      errorMsg = BULK_UPLOAD.EXCEL_ERROR_MSG.INVALID_BULK_SIMSWAP_NEWSIM;
      errorKey = BULK_UPLOAD.INVALID_ACCOUNT_NUMBER_ERR_KEY;
    } else {
      count = VALUE.ONE;
      errorMsg = BULK_UPLOAD.EXCEL_ERROR_MSG.MISSING_BULK_SIMSWAP_NEWSIM;
      errorKey = BULK_UPLOAD.MISSING_ACCOUNT_NUMBER_ERR_KEY;
    }
    if (count === VALUE.ONE) {
      /** When both EID and NewSim are entered with invalid format(csv), then show error msg "delete EID / delete NewSim" */
      if(this.eSimEnabled && data[BULK_UPLOAD.BULK_SIMSWAP_EID_Txt] !== COMMON_CONSTANTS.STRING_EMPTY && data[tempKey] !== COMMON_CONSTANTS.STRING_EMPTY){
        errorMsg = BULK_UPLOAD.EXCEL_ERROR_MSG.DELETE_EID_NEWSIM;
        errorKey = BULK_UPLOAD.MISSING_ACCOUNT_NUMBER_ERR_KEY;
        this.addError(data, errorKey, errorMsg, true);
      }else{
        this.addError(data, errorKey, errorMsg, true);
      }
    }else if(this.eSimEnabled && data[BULK_UPLOAD.BULK_SIMSWAP_EID_Txt] !== COMMON_CONSTANTS.STRING_EMPTY && data[tempKey] !== COMMON_CONSTANTS.STRING_EMPTY){
       /** When both EID and NewSim are entered with valid format, then show error msg "delete EID / delete NewSim" */
      errorMsg = BULK_UPLOAD.EXCEL_ERROR_MSG.DELETE_EID_NEWSIM;
      errorKey = BULK_UPLOAD.MISSING_ACCOUNT_NUMBER_ERR_KEY;
      this.addError(data, errorKey, errorMsg, true);
    }
  }
  validateReasonForSimSwap(value) {
    const validate = _.find(SIM_SWAP_REASONS, { description: value });
    return !_.isEmpty(validate);
  }

  simSwapErrorCheck(value, colDef) {
    if (value != null && colDef != null) {
      switch (colDef.headerName) {
        case BULK_UPLOAD.BULK_PHONE_NUMBER_TXT:
          if (value.toString().length === 10 && !isNaN(+value)) {
            return 0;
          }
          return 1;
        case 'OldSim':
        case 'NewSim':
        case 'NewSIM (for Physical SIM)':
          return this.oldAndNewSimCases(value);
        case 'EID (for eSIM)':
          if (this.regex32.test(value)) {
            return 0;
          }
          return 1;
        case BULK_UPLOAD.BULK_SIMSWAP_REASON_FOR_CHANGE_Txt:
          // tslint:disable-next-line: no-angle-bracket-type-assertion
          const rangeValues = <string[]>colDef.range;
          if (rangeValues.indexOf(value) > -1) {
            return 0;
          }
          return 1;
        default: return 0;
      }
    }
  }
  oldAndNewSimCases(value){
    if (this.regex19.test(value) || this.regex20.test(value)) {
      return 0;
    }
    return 1;
  }
  commonValidation(line, reg) {
    if (!line.PhoneNumber || !this.mobileRegexValidationCheck(line.PhoneNumber.toString(),reg)) {
      this.showPhoneErrorMsg();
      return true;
    } else {
      return false;
    }
  }

  mobileRegexValidationCheck(phoneNumber,pattern){
    phoneNumber = phoneNumber.trim().replace(/[^0-9]/g, '');
    let non_geo_pattern = COMMON_CONSTANTS.NON_GEO_REGEX;
    if(COMMON_CONSTANTS.NON_GEO__AREA_CODE.includes(phoneNumber.substring(0,3)) === false){
      return pattern.test(phoneNumber);
    }else if (COMMON_CONSTANTS.NON_GEO__COUNTRY_CODE_EXCLUDES.includes(phoneNumber.substring(3,6)) === false){
      return non_geo_pattern.test(phoneNumber);
    }else{
      return false;
    }
  }
  commonValidationLineIdentifier(line, reg) {
    line.PhoneNumber = line.PhoneNumber.toString().replace(/[^0-9]/g, '');
    if (!line.Ban || line.Ban.length !== COMMON_CONSTANTS.DIGITS.NINE) {
      this.showBanErrorMsg();
      return true;
    } else if (!line.PhoneNumber || !this.mobileRegexValidationCheck(line.PhoneNumber,reg)) {
      this.showPhoneErrorMsgLineIdentifier();
      return true;
    } else {
      return false;
    }
  }

  commonValidationTpop(line, reg) {
    line.PhoneNumber = line.PhoneNumber?.toString().replace(/[^0-9]/g, '');
    if (!line.AccountNumber || line.AccountNumber?.length !== COMMON_CONSTANTS.DIGITS.NINE) {
      this.showBanErrorMsg();
      return true;
    } else if (!line.PhoneNumber || !this.mobileRegexValidationCheck(line.PhoneNumber,reg)) {
      this.showPhoneErrorMsg();
      return true;
    } else {
      return false;
    }
  }

  showBanErrorMsg() {
    this.popuperror = this.authoringContentData?.lineIdentifierAuthoring?.popUpErrorBanNumberTxt ? this.authoringContentData.lineIdentifierAuthoring.popUpErrorBanNumberTxt : '';
  }

  showPhoneErrorMsgLineIdentifier() {
      this.popuperror = this.authoringContentData?.lineIdentifierAuthoring?.popUpErrorPhoneTxt ? this.authoringContentData.lineIdentifierAuthoring.popUpErrorPhoneTxt : '';
  }

  findDuplicateMSISDNandNumberToTransfer(sheetData: any, keyname: string) {
    switch (keyname) {
      case BULK_UPLOAD.MSISDN_NUMBER_TXT:
        this.duplicateMSISDN = sheetData.map((e) => e[BULK_UPLOAD.MSISDN_NUMBER_TXT])
          .map((e, i, final) => final.indexOf(e) !== i && i)
          .filter((obj) => sheetData[obj])
          .map((e) => sheetData[e][BULK_UPLOAD.MSISDN_NUMBER_TXT]);
        this.duplicateMSISDNObj = sheetData.filter((obj) => this.duplicateMSISDN.includes(obj[BULK_UPLOAD.MSISDN_NUMBER_TXT]));
        if (this.duplicateMSISDNObj.length > VALUE.ZERO) {
          return true;
        }
        return false;
      case BULK_UPLOAD.NUMBER_TO_TRANSFER_TXT:
        this.duplicateNumberToTransfer = sheetData.map((e) => e[BULK_UPLOAD.NUMBER_TO_TRANSFER_TXT])
          .map((e, i, final) => final.indexOf(e) !== i && i)
          .filter((obj) => sheetData[obj])
          .map((e) => sheetData[e][BULK_UPLOAD.NUMBER_TO_TRANSFER_TXT]);
        this.duplicateNumberToTransferObj = sheetData.filter((obj) => this.duplicateNumberToTransfer.includes(obj[BULK_UPLOAD.NUMBER_TO_TRANSFER_TXT]));
        if (this.duplicateNumberToTransferObj.length > VALUE.ZERO) {
          return true;
        }
        return false;
      case BULK_UPLOAD.BULK_PHONE_NUMBER_TXT:
        const filteredObject = sheetData.filter((x) => x[BULK_UPLOAD.BULK_PHONE_NUMBER_TXT] !== '');
        const duplicatePhoneNumber = filteredObject.map((e) => e[BULK_UPLOAD.BULK_PHONE_NUMBER_TXT])
          .map((e, i, final) => final.indexOf(e) !== i && i)
          .filter((obj) => filteredObject[obj])
          .map((e) => filteredObject[e][BULK_UPLOAD.BULK_PHONE_NUMBER_TXT]);
        const duplicatePhoneNumberObj = filteredObject.filter((obj) => duplicatePhoneNumber.includes(obj[BULK_UPLOAD.BULK_PHONE_NUMBER_TXT]));
        if (duplicatePhoneNumberObj.length > VALUE.ZERO) {
          return true;
        }
        return false;
    }
  }

  returnDuplicateFlag(uniqueValue,nonEmptyLine){
    if (uniqueValue.size < nonEmptyLine.length) {
      return true;
    }else{
      return false;
    }
  }
  findDuplicateSIM(sheetData: any, keyname: string) {
    if(this.eSimEnabled){
      if(keyname === BULK_UPLOAD.BULK_SIMSWAP_NEWSIM_Txt){keyname = BULK_UPLOAD.BULK_ESIMSWAP_NEWSIM_Txt;}
      let sheetDataArray:any = sheetData;
      let nonEmptyLine = sheetDataArray.filter(item => item[keyname] !== "");
      let uniqueValue = new Set(nonEmptyLine.map(v => v[keyname]));
      return this.returnDuplicateFlag(uniqueValue,nonEmptyLine);
    }else{
      switch (keyname) {
        case BULK_UPLOAD.BULK_SIMSWAP_OLDSIM_Txt:
          const duplicateOldSimNumber = sheetData.map((e) => e[BULK_UPLOAD.BULK_SIMSWAP_OLDSIM_Txt])
            .map((e, i, final) => final.indexOf(e) !== i && i)
            .filter((obj) => sheetData[obj])
            .map((e) => sheetData[e][BULK_UPLOAD.BULK_SIMSWAP_OLDSIM_Txt]);
          const duplicateOldSimObj = sheetData.filter((obj) => duplicateOldSimNumber.includes(obj[BULK_UPLOAD.BULK_SIMSWAP_OLDSIM_Txt]));
          if (duplicateOldSimObj.length > VALUE.ZERO) {
            return true;
          }
          return false;
        case BULK_UPLOAD.BULK_SIMSWAP_NEWSIM_Txt:
        const duplicateNewSimNumber = sheetData.map((e) => e[BULK_UPLOAD.BULK_SIMSWAP_NEWSIM_Txt])
            .map((e, i, final) => final.indexOf(e) !== i && i)
            .filter((obj) => sheetData[obj])
            .map((e) => sheetData[e][BULK_UPLOAD.BULK_SIMSWAP_NEWSIM_Txt]);
          const duplicateNewSimObj = sheetData.filter((obj) => duplicateNewSimNumber.includes(obj[BULK_UPLOAD.BULK_SIMSWAP_NEWSIM_Txt]));
          if (duplicateNewSimObj.length > VALUE.ZERO) {
            return true;
          }
          return false;
      }
    }
  }

  isPhoneNumberInvalid(sheetData: any) {
    // tslint:disable-next-line: max-line-length
    const regeX = /^(?:(?:\+?1\s*(?:[.-]\s*)?)?(?:\(\s*([2-9]1[02-9]|[2-9][02-8]1|[2-9][02-8][02-9])\s*\)|([2-9]1[02-9]|[2-9][02-8]1|[2-9][02-8][02-9]))\s*(?:[.-]\s*)?)?([2-9]1[02-9]|[2-9][02-9]1|[2-9][02-9]{2})\s*(?:[.-]\s*)?([0-9]{4})(?:\s*(?:#|x\.?|ext\.?|extension)\s*(\d+))?$/;
    if (sheetData != null) {
      const invalidPhoneNumberObj = sheetData.filter((res: any) => res.PhoneNumber === '' || res.PhoneNumber == null || !this.mobileRegexValidationCheck(res.PhoneNumber.toString(),regeX));
      if (invalidPhoneNumberObj.length > VALUE.ZERO) {
        return true;
      } else {
        return false;
      }
    }
  }

  validatePhoneNumberKey(result) {
    this.total = result.length;
    let isDuplicatePhoneNumber = false;
    let isDuplicateOldSimNumber = false;
    let isDuplicateEIDNumber = false;
    let isDuplicateNewSimNumber = false;
    let restorePhoneNumberInvalid = false;
    // tslint:disable-next-line:max-line-length
    const reg = /^(?:(?:\+?1\s*(?:[.-]\s*)?)?(?:\(\s*([2-9]1[02-9]|[2-9][02-8]1|[2-9][02-8][02-9])\s*\)|([2-9]1[02-9]|[2-9][02-8]1|[2-9][02-8][02-9]))\s*(?:[.-]\s*)?)?([2-9]1[02-9]|[2-9][02-9]1|[2-9][02-9]{2})\s*(?:[.-]\s*)?([0-9]{4})(?:\s*(?:#|x\.?|ext\.?|extension)\s*(\d+))?$/;
    // tslint:disable-next-line: max-line-length
    // const reg =  /^(200[0-8][0-9]{6}|2009[0-8][0-9]{5}|20099[0-8][0-9]{4}|200999[0-8][0-9]{3}|2009999[0-8][0-9]{2}|20099999[0-8][0-9]|200999999[0-9]|20[2-9][2-9]{7}|2[2-9][2-9]{8}|[3-9][0-9]{9})$/;
    let flag = false;
    if (!this.validateUploadedSheet(result, this.bulkFlow)) {
      this.popuperror = this.authoringContentData?.bulkFlow?.errorWhileUploadingTxt ? this.authoringContentData.bulkFlow.errorWhileUploadingTxt : '';
      this.validatingPhoneNumber = -1;
    } else {
      this.progress = 0;
      this.setTimeoutRefList = [];
      for (const line of result) {
        const setTimeoutRef = setTimeout(() => {
          if (this.stopProcessing) {
            return;
          }
          this.progress++;
          // tslint:disable-next-line:max-line-length
          if (this.templateType === BULK_UPLOAD.CSV_TXT && line?.PhoneNumber) {
            line.PhoneNumber = typeof line.PhoneNumber === 'string' ? Number(line.PhoneNumber.replace(/-/g, '')) : line.PhoneNumber;
          }
          if (this.templateType === BULK_UPLOAD.XLSX_TXT && this.bulkFlow === BULK_UPLOAD.TRANSFER_NUMBERS && line[BULK_UPLOAD.MSISDN_NUMBER_TXT] != null) {
            line[BULK_UPLOAD.MSISDN_NUMBER_TXT] = typeof line[BULK_UPLOAD.MSISDN_NUMBER_TXT] === 'string' ?
              Number(line[BULK_UPLOAD.MSISDN_NUMBER_TXT].replace(/\D/g, '')) : line[BULK_UPLOAD.MSISDN_NUMBER_TXT];
          }
          if (this.templateType === BULK_UPLOAD.XLSX_TXT && this.bulkFlow === BULK_UPLOAD.TRANSFER_NUMBERS && line[BULK_UPLOAD.NUMBER_TO_TRANSFER_TXT] != null) {
            line[BULK_UPLOAD.NUMBER_TO_TRANSFER_TXT] = typeof line[BULK_UPLOAD.NUMBER_TO_TRANSFER_TXT] === 'string' ?
              Number(line[BULK_UPLOAD.NUMBER_TO_TRANSFER_TXT].replace(/\D/g, '')) : line[BULK_UPLOAD.NUMBER_TO_TRANSFER_TXT];
          }
          // tslint:disable-next-line: prefer-conditional-expression
          if (line?.OldSim && this.findDuplicateSIM(result, BULK_UPLOAD.BULK_SIMSWAP_OLDSIM_Txt)) {
            isDuplicateOldSimNumber = true;
          } else {
            isDuplicateOldSimNumber = false;
          }
          if (this.eSimEnabled && line[BULK_UPLOAD.BULK_SIMSWAP_EID_Txt] && this.findDuplicateSIM(result, BULK_UPLOAD.BULK_SIMSWAP_EID_Txt)) {
            isDuplicateEIDNumber = true;
          }
          // tslint:disable-next-line: prefer-conditional-expression
          if ((line?.NewSim || line[BULK_UPLOAD.BULK_ESIMSWAP_NEWSIM_Txt]) && this.findDuplicateSIM(result, BULK_UPLOAD.BULK_SIMSWAP_NEWSIM_Txt)) {
            isDuplicateNewSimNumber = true;
          }else if(!this.eSimEnabled){
            isDuplicateNewSimNumber = false;
          }
          if (line?.PhoneNumber && this.findDuplicateMSISDNandNumberToTransfer(result, BULK_UPLOAD.BULK_PHONE_NUMBER_TXT)) {
            isDuplicatePhoneNumber = true;
          } else if (line[BULK_UPLOAD.MSISDN_NUMBER_TXT] != null && this.findDuplicateMSISDNandNumberToTransfer(result, BULK_UPLOAD.MSISDN_NUMBER_TXT)) {
            isDuplicatePhoneNumber = true;
          } else {
            isDuplicatePhoneNumber = false;
          }
          switch (this.bulkFlow) {
            case BULK_UPLOAD.CHANGE_PHONE_KEY:
              flag = this.commonValidation(line, reg);
              break;
            case BULK_UPLOAD.SIM_SWAP_KEY:
              if (line?.OldSim && (!line?.PhoneNumber || (!reg.test(line?.PhoneNumber)))) {
                this.popuperror = this.authoringContentData?.bulkFlow?.bulkSimSwapError ? this.authoringContentData.bulkFlow.bulkSimSwapError : '';
                flag = true;
              } else if ((line.OldSim === '' && line.PhoneNumber === '') || (line.PhoneNumber === '' && line.OldSim && (!this.regex20.test(line.OldSim)))) {
                this.showOldSimErrorMsg();
                flag = true;
              }
              break;
            case BULK_UPLOAD.SUSPEND_KEY:
              flag = this.commonValidation(line, reg);
              break;
            case BULK_UPLOAD.RESTORE_KEY:
              if (this.isPhoneNumberInvalid(result)) {
                restorePhoneNumberInvalid = true;
                flag = true;
              } else {
                flag = false;
                restorePhoneNumberInvalid = false;
              }
              break;
            case BULK_UPLOAD.TRANSFER_NUMBERS:
              const tempKeys = Object.keys(line);
              if (tempKeys[0] !== BULK_UPLOAD.MSISDN_NUMBER_TXT) {
                this.popuperror = this.authoringContentData?.transferNumberAuthoring?.fileTypeNotSupported ? this.authoringContentData.transferNumberAuthoring.fileTypeNotSupported : '';
                flag = true;
              } else if (!reg.test(line[BULK_UPLOAD.MSISDN_NUMBER_TXT])) {
                this.showTransferNumberErrorMsg(BULK_UPLOAD.MSISDN_NUMBER_TXT);
                flag = true;
              } else if (isDuplicatePhoneNumber) {
                this.showTransferNumberErrorMsg(BULK_UPLOAD.DUPLICATE_NUMBER_TXT);
                flag = true;
              }
              break;
            case BULK_UPLOAD.LINE_IDENTIFIER:
              if (!flag) {
                flag = this.commonValidationLineIdentifier(line, reg);
              }
              break;
            case BULK_UPLOAD.CANCEL_SUBSCRIBER:
              flag = this.commonValidation(line, reg);
              break;
            case BULK_UPLOAD.CHANGE_SERVICE:
              flag = this.commonValidation(line, reg);
              break;
            case BULK_UPLOAD.MANAGE_PAIRING:
              flag = false;
              break;
            case BULK_UPLOAD.STRATEGIC_PORT_IN:
              flag = false;
              break;
            case BULK_UPLOAD.TPOP_KEY:
              flag = this.commonValidationTpop(line, reg);
              break;
          }

          this.fileUploadingPercentage = (this.progress / result.length) * 100;
          if (this.progress === result.length) {
            if (restorePhoneNumberInvalid) {
              this.showPhoneErrorMsg();
            }
            if (flag) {
              this.validatingPhoneNumber = -1;
            } else {
              if (isDuplicatePhoneNumber) {
                this.showDuplicatePhoneErrorMsg();
                this.validatingPhoneNumber = -1;
              } else if (isDuplicateOldSimNumber || isDuplicateEIDNumber || isDuplicateNewSimNumber) {
                this.showSimErrorMsg(isDuplicateOldSimNumber,isDuplicateEIDNumber,isDuplicateNewSimNumber);
              } else {
                this.validatingPhoneNumber = 1;
              }
            }
            this.handleSpecificValidations(result);
          }
        }, 25);
        this.setTimeoutRefList.push(setTimeoutRef);
      }
    }
  }

  showHeaderErrorMsg() {
    this.popuperror = this.authoringContentData?.bulkFlow?.headerIsnotCorrect ? this.authoringContentData.bulkFlow.headerIsnotCorrect : '';
    if (this.templateType === BULK_UPLOAD.XLSX_TXT && this.bulkFlow === BULK_UPLOAD.RESTORE_KEY ||
      this.bulkFlow === BULK_UPLOAD.SUSPEND_KEY) {
      this.popuperror = this.authoringContentData?.bulkFlow?.errorWhileUploadingTxt ? this.authoringContentData.bulkFlow.errorWhileUploadingTxt : '';
    }
  }

  showPhoneErrorMsg() {
         this.popuperror = this.authoringContentData?.bulkFlow?.popUpErrorOneTxt ? this.authoringContentData.bulkFlow.popUpErrorOneTxt : '';

  }

  showSimErrorMsg(isDuplicateOldSimNumber,isDuplicateEIDNumber,isDuplicateNewSimNumber) {
    if(this.eSimEnabled){
     this.showSimErrorMsgForEsim(isDuplicateOldSimNumber,isDuplicateEIDNumber,isDuplicateNewSimNumber);
    }else{
      this.popuperror = this.authoringContentData !== undefined && this.authoringContentData.changeSim !== undefined && this.authoringContentData.changeSim.duplicateSimNumberErrMsg !== undefined ? this.authoringContentData.changeSim.duplicateSimNumberErrMsg : '';
    }
  }
  showSimErrorMsgForEsim(isDuplicateOldSimNumber,isDuplicateEIDNumber,isDuplicateNewSimNumber){
    let content:any = (this.authoringContentData !== undefined && this.authoringContentData.changeSim !== undefined);
    if(isDuplicateOldSimNumber){
      this.popuperror = (content && this.authoringContentData.changeSim.duplicateOldSimNumberErrMsg !== undefined) ? this.authoringContentData.changeSim.duplicateOldSimNumberErrMsg : '';
    }else if(isDuplicateEIDNumber){
      this.popuperror = (content && this.authoringContentData.changeSim.duplicateEIDNumberErrMsg !== undefined) ? this.authoringContentData.changeSim.duplicateEIDNumberErrMsg : '';
    }else if(isDuplicateNewSimNumber){
      this.popuperror = (content && this.authoringContentData.changeSim.duplicateNewSimNumberErrMsg !== undefined) ? this.authoringContentData.changeSim.duplicateNewSimNumberErrMsg : '';
    }
  }
  showTransferNumberErrorMsg(param: string) {
    switch (param) {
      case BULK_UPLOAD.MSISDN_NUMBER_TXT:
        this.popuperror = this.authoringContentData?.transferNumberAuthoring?.blankErrMsgForMSISDN ? this.authoringContentData.transferNumberAuthoring.blankErrMsgForMSISDN : '';
        break;
      case BULK_UPLOAD.DUPLICATE_NUMBER_TXT:
        this.popuperror = this.authoringContentData?.transferNumberAuthoring?.duplicateNumberErrMsg ? this.authoringContentData.transferNumberAuthoring.duplicateNumberErrMsg : '';
    }
  }

  showOldSimErrorMsg() {
    this.popuperror = this.authoringContentData?.bulkFlow?.invalidOldSimErrTxt ? this.authoringContentData.bulkFlow.invalidOldSimErrTxt : '';
  }

  validateUploadedSheet(sheetData, flowType) {
    const tempKeys = Object.keys(sheetData[0]).toString();

    switch (flowType) {
      case BULK_UPLOAD.CHANGE_PHONE_KEY:
        if (tempKeys !== BULK_UPLOAD.CHANGE_NUMBER_SHEET_KEYS.toString()) {
          this.isChangeNumberValidSheet = false;
        } else {
          this.isChangeNumberValidSheet = true;
        }
        return tempKeys === BULK_UPLOAD.CHANGE_NUMBER_SHEET_KEYS.toString();
      case BULK_UPLOAD.SIM_SWAP_KEY:
        if(this.eSimEnabled){
          return tempKeys === BULK_UPLOAD.ESIM_CHANGE_SHEET_KEYS.toString();
        }
        return tempKeys === BULK_UPLOAD.SIM_CHANGE_SHEET_KEYS.toString();
      case BULK_UPLOAD.SUSPEND_KEY:
        return !this.isOkta ?  (tempKeys === BULK_UPLOAD.SUSPEND_SHEET_KEYS_IAM.toString()) : (tempKeys === BULK_UPLOAD.SUSPEND_SHEET_KEYS.toString());
      case BULK_UPLOAD.RESTORE_KEY:
        return tempKeys === BULK_UPLOAD.RESTORE_SHEET_KEYS.toString();
      case BULK_UPLOAD.TRANSFER_NUMBERS:
        return tempKeys === BULK_UPLOAD.TRANSFER_NUMBER_SHEET_KEYS.toString();
      case BULK_UPLOAD.LINE_IDENTIFIER:
        let tempColumns = [BULK_UPLOAD.BAN_TXT, BULK_UPLOAD.PHONE_NUMBER_TXT];
        const configModel = this.utilsSvc.createConfigModel();
        for (const config of configModel) {
          if (!this.banListingBlkTop) {
            tempColumns.push(BULK_UPLOAD.CURRENT_TXT + COMMON_CONSTANTS.STRING_SPACE + (config.configLabel + COMMON_CONSTANTS.STRING_SPACE + config.configDesc).trim());
          }
          let updatedCol = this.getUpdatedCol(config);
          tempColumns.push(updatedCol);
        }
        tempColumns = _.uniq(tempColumns);  // temp solution will remove after confirmation
        return tempKeys === tempColumns.toString();
      case BULK_UPLOAD.CANCEL_SUBSCRIBER:
        return tempKeys === BULK_UPLOAD.CANCEL_SUBSCRIBER_KEYS.toString();
      case BULK_UPLOAD.CHANGE_SERVICE:
        return tempKeys.includes(BULK_UPLOAD.PHONE_NUMBER_TXT);
      case BULK_UPLOAD.MANAGE_PAIRING:
        return tempKeys === BULK_UPLOAD.MANAGE_PAIRING_KEYS.toString();
      case BULK_UPLOAD.STRATEGIC_PORT_IN:
        return tempKeys === BULK_UPLOAD.STRATEGIC_PORT_IN_KEYS.toString();
        case BULK_UPLOAD.TPOP_KEY:
          return tempKeys === BULK_UPLOAD.TPOP_BULK_KEYS.toString();
      default:
        return false;
    }
  }

  getUpdatedCol(config){
    if(environment.ENABLE_DH_UDF && config.configName == LINE_IDENTIFIER.CONFIG_UDFID6){
      if(this.templateType === BULK_UPLOAD.CSV_TXT){
        return (this.authoringContentData.bulkFlow.bulkUploadUDFExtraColumnDescription + COMMON_CONSTANTS.NEW_LINE + BULK_UPLOAD.UPDATED_TXT + COMMON_CONSTANTS.STRING_SPACE + (config.configLabel + COMMON_CONSTANTS.STRING_SPACE + config.configDesc).trim());
      } else {
        return (this.authoringContentData.bulkFlow.bulkUploadUDFExtraColumnDescription + COMMON_CONSTANTS.NEW_LINE_R + BULK_UPLOAD.UPDATED_TXT + COMMON_CONSTANTS.STRING_SPACE + (config.configLabel + COMMON_CONSTANTS.STRING_SPACE + config.configDesc).trim());
      }
    } else{
      return (BULK_UPLOAD.UPDATED_TXT + COMMON_CONSTANTS.STRING_SPACE + (config.configLabel + COMMON_CONSTANTS.STRING_SPACE + config.configDesc).trim());
    }
  }
  validateTransferNumberSheet(sheetData) {
    // tslint:disable-next-line: no-angle-bracket-type-assertion
    const colDefs = <ColumnDefinition[]>transferColumnsDefinition;
    let count = VALUE.ZERO;
    let errorCountPerRow = VALUE.ZERO;
    let issuesFound = VALUE.ZERO;
    if (colDefs != null && sheetData?.length > VALUE.ZERO) {
      sheetData.forEach((data) => {
        let date = "";
        if (data != null) {
          if (count >= VALUE.ZERO) {
            issuesFound += count;
            const tempKeys = Object.keys(data);
            if (tempKeys != null) {
              for (const tempKey of tempKeys) {
                const colDef = colDefs.find((col) => col.headerName === tempKey);
                const value = data[tempKey];
                switch (tempKey) {
                  case BULK_UPLOAD.NUMBER_TO_TRANSFER_TXT:
                    this.findDuplicateMSISDNandNumberToTransfer(sheetData, BULK_UPLOAD.NUMBER_TO_TRANSFER_TXT);
                    if (data[BULK_UPLOAD.NUMBER_TO_TRANSFER_TXT] != null) {
                      data[BULK_UPLOAD.NUMBER_TO_TRANSFER_TXT] = typeof data[BULK_UPLOAD.NUMBER_TO_TRANSFER_TXT] === 'string' ?
                        Number(data[BULK_UPLOAD.NUMBER_TO_TRANSFER_TXT].replace(/-/g, '')) : data[BULK_UPLOAD.NUMBER_TO_TRANSFER_TXT];
                    }
                    if (value) {
                      count = this.validationForTransferNumber(value, colDef);
                      if (count === VALUE.ONE) {
                        errorCountPerRow += count;
                        this.addError(data, BULK_UPLOAD.INVALID_NUMBER_TO_TRANSFER_ERR_KEY, BULK_UPLOAD.EXCEL_ERROR_MSG.MISSING_INVALID_NUMBER_TO_TRANSFER);
                      }
                    }
                    const isDuplicate = this.duplicateNumberToTransfer.includes(data[BULK_UPLOAD.NUMBER_TO_TRANSFER_TXT]);
                    if (isDuplicate) {
                      errorCountPerRow += count;
                      this.addError(data, BULK_UPLOAD.DUPLICATE_NUMBER_TO_TRANSFER_ERR_KEY, BULK_UPLOAD.EXCEL_ERROR_MSG.DUPLICATE_PHONE_NUMBER_ERR_MSG);
                    }
                    const transferNumberDuplicateOfMSISDN = sheetData.filter((obj) => obj[BULK_UPLOAD.MSISDN_NUMBER_TXT] === data[BULK_UPLOAD.NUMBER_TO_TRANSFER_TXT]);
                    const isTransferNumberDuplicateofMSISDN = transferNumberDuplicateOfMSISDN.some((obj) => obj[BULK_UPLOAD.MSISDN_NUMBER_TXT] === data[BULK_UPLOAD.NUMBER_TO_TRANSFER_TXT]);
                    if (isTransferNumberDuplicateofMSISDN) {
                      errorCountPerRow += count;
                      data = this.addError(data, BULK_UPLOAD.SAME_AS_MSISDN_ERR_KEY, BULK_UPLOAD.EXCEL_ERROR_MSG.NUMBER_TO_TRANSFER_NOT_BE_SAME_AS_MSISDN);
                    }
                    break;
                  case BULK_UPLOAD.CARRIER_ACCOUNT_NUMBER:
                    if (value) {
                      count = this.validationForTransferNumber(value, colDef);
                      if (count === VALUE.ONE) {
                        errorCountPerRow += count;
                        data = this.addError(data, BULK_UPLOAD.INVALID_ACCOUNT_NUMBER_ERR_KEY, BULK_UPLOAD.EXCEL_ERROR_MSG.INVALID_CARRIER_ACCOUNT_NUMBER);
                      }
                    } else {
                      count = VALUE.ONE;
                      errorCountPerRow += count;
                      data = this.addError(data, BULK_UPLOAD.MISSING_ACCOUNT_NUMBER_ERR_KEY, BULK_UPLOAD.EXCEL_ERROR_MSG.MISSING_CARRIER_ACCOUNT_NUMBER);
                    }
                    break;
                  case BULK_UPLOAD.PORT_DATE_TXT:
                    if (value) {
                      count = this.validationForTransferNumber(value, colDef);
                      if (count === VALUE.ONE) {
                        errorCountPerRow += count;
                        data = this.addError(data, BULK_UPLOAD.INVALID_PORT_DATE_ERR_KEY, BULK_UPLOAD.EXCEL_ERROR_MSG.INVALID_PORT_DATE);
                      }
                      else{
                        date = value;
                      }
                    } else {
                      count = VALUE.ONE;
                      errorCountPerRow += count;
                      data = this.addError(data, BULK_UPLOAD.MISSING_PORT_DATE_ERR_KEY, BULK_UPLOAD.EXCEL_ERROR_MSG.MISSING_PORT_DATE);
                    }
                    break;
                  case BULK_UPLOAD.PORT_START_TIME_TXT:
                    if (value) {
                      count = this.validationForTransferNumber(value, colDef, date);
                      if (count === VALUE.ONE) {
                        errorCountPerRow += count;
                        data = this.addError(data, BULK_UPLOAD.INVALID_PORT_TIME_ERR_KEY, BULK_UPLOAD.EXCEL_ERROR_MSG.INVALID_PORT_TIME);
                      }
                    }
                    break;
                }
              }
            }
            issuesFound = errorCountPerRow;
          }
        }
      });
    } else {
      return VALUE.MINUS_ONE;
    }
    // tslint:disable-next-line: prefer-object-spread
    this.transformInlineErrorObject = Object.assign([], sheetData);
    return issuesFound;
  }

  validateLineIdentifierSheet(sheetData) {
    // need to implement validation for line identifier sheet data
    return COMMON_CONSTANTS.DIGITS.ZERO;
  }

  validateTransferNumCase(valid: boolean) {
    if (valid) {
      this.transferMsgFlag = true;
      return VALUE.ZERO;
    }
    this.transferMsgFlag = false;
    return VALUE.ONE;
  }

  validationForTransferNumber(value: string, colDef: any, columnDate = "") {
    if (value != null && colDef != null) {
      let condition: boolean;
      switch (colDef.headerName) {
        case BULK_UPLOAD.NUMBER_TO_TRANSFER_TXT:
          condition = value && value.toString().length === VALUE.TEN && !isNaN(+value);
          return this.validateTransferNumCase(condition);
        case BULK_UPLOAD.CARRIER_ACCOUNT_NUMBER:
          condition = value && value.toString().length >= VALUE.ONE && value.toString().length <= VALUE.THIRTY;
          return this.validateTransferNumCase(condition);
        case BULK_UPLOAD.PORT_DATE_TXT:
          const pstDateResponse = ContentService.GetCache(COMMON_CONSTANTS.PORT_IN_PST_DATE);
          const currentDate = pstDateResponse.currentPstDate;
          const portDate = value;
          const logicalDate = pstDateResponse.portInMaxDate;
          let dateRegex = COMMON_CONSTANTS.DATE_REGEX;
          condition = dateRegex.test(portDate) && new Date(portDate) >= new Date(currentDate) && new Date(portDate) <= new Date(logicalDate);
          return this.validateTransferNumCase(condition);
        case BULK_UPLOAD.PORT_START_TIME_TXT: {
          const timeFormatRegex = BULK_UPLOAD.TIME_FORMAT_REGEX;
          if (timeFormatRegex.test(value) === true) {
            if (columnDate.length > 0) {
              const pstDateResponse = ContentService.GetCache(COMMON_CONSTANTS.PORT_IN_PST_DATE);
              const currentDate = pstDateResponse.currentPstDate;
              const portDate = columnDate;
              const currentDateime = pstDateResponse.currentPstDateTime;
              const portDateTime = this.utilsSvc.getPortInDateTime(portDate, value);
              if (new Date(portDate).getDate() === new Date(currentDate).getDate()) {
                if (new Date(portDateTime).getTime() > new Date(currentDateime).getTime()) {
                  this.transferMsgFlag = true;
                  return VALUE.ZERO;
                }
                else {
                  this.showTimeErrorBelowReviewStatement = true;
                  this.transferMsgFlag = false;
                  return VALUE.ONE;
                }
              }
            }
            this.transferMsgFlag = true;
            return VALUE.ZERO;
          } else {
            this.transferMsgFlag = false;
            return VALUE.ONE;
          }
        }
  
      }
    }
  }

  validationForChangeNumber(value: string, colDef: any) {
    if (value != null && colDef != null) {
      switch (colDef.headerName) {
        case BULK_UPLOAD.BULK_PHONE_NUMBER_TXT:
          if (value && value.toString().length === VALUE.TEN && !isNaN(+value)) {
            this.transferMsgFlag = true;
            return VALUE.ZERO;
          } else {
            this.transferMsgFlag = false;
            return VALUE.ONE;
          }
        case BULK_UPLOAD.CARRIER_ACCOUNT_NUMBER:
          if (value && value.toString().length === 3 && !isNaN(+value)) {
            this.transferMsgFlag = true;
            return VALUE.ZERO;
          } else {
            this.transferMsgFlag = false;
            return VALUE.ONE;
          }
        case BULK_UPLOAD.BULK_SIMSWAP_REASON_FOR_CHANGE_Txt:
          this.switchCaseForReasonChange(value);
      }
    }
  }

  switchCaseForReasonChange(value){
    if (value) {
      this.transferMsgFlag = true;
      return VALUE.ZERO;
    } else {
      this.transferMsgFlag = false;
      return VALUE.ONE;
    }
  }

  submitTransferDataAfterUpload(records: any) {
    this.recordsWithErrors = records.filter((item) => item[BULK_UPLOAD.ERROR_KEY] !== undefined);
    this.recordsWithoutErrors = records.filter((item) => item[BULK_UPLOAD.ERROR_KEY] === undefined);

    this.itemsUploadedSuccessfully = this.recordsWithoutErrors.length;
    if (this.recordsWithErrors.length === VALUE.ZERO) {
      this.popuperror = null;
      const recordsWithNoErrors = [];
      recordsWithNoErrors.push(this.recordsWithoutErrors);
      ContentService.SetCache(BULK_UPLOAD.BULK_UPLOAD_REQUEST_KEY, recordsWithNoErrors);
    } else {
      if (this.recordsWithErrors.length >= VALUE.THIRTEEN || this.recordsWithErrors.length < VALUE.THIRTEEN) {
        const transferNumberArray = [];
        transferNumberArray.push(this.recordsWithoutErrors);
        transferNumberArray.push(this.recordsWithErrors);
        this.transferNumberLines = this.recordsWithoutErrors;
        this.linesWithError = this.recordsWithErrors;
        if(!this.showTimeErrorBelowReviewStatement){
          this.setCacheAndOpenModel(transferNumberArray);
        }
      }
    }
  }

  submitLineIdentifierDataAfterUpload(records: any) {
    this.recordsWithErrors = records.filter((item) => item[BULK_UPLOAD.ERROR_KEY] !== undefined);
    this.recordsWithoutErrors = records.filter((item) => item[BULK_UPLOAD.ERROR_KEY] === undefined);
    const lineIdentifierArray = [];
    lineIdentifierArray.push(this.recordsWithoutErrors);
    lineIdentifierArray.push(this.recordsWithErrors);
    this.setCacheAndOpenModel(lineIdentifierArray);
  }

  setArrayInErrorObject(error) {
    const errorObj = error.error;
    const errorArray = [];
    Object.keys(errorObj).forEach(function (key) {
      errorArray.push({ [key]: errorObj[key] });    
    });
    error.error = errorArray;
  }

  submitTransferNumberRequest() {
    this.generateClickTag({
      type: ANALYTICS.CLICK_TO_NAVIGATE,
      action: ANALYTICS.CLICK,
      ctaName: ANALYTICS.SUBMIT,
      assetType: ANALYTICS.BUTTON,
      modalName: this.title,
      stage: ANALYTICS.INPROGRESSSTAGE,
      name: this.title
    });

    this.portinLines = this.recordsWithoutErrors;
    this.requestPortin = this.utilsSvc.updatedPortinBulkRequestHeader(this.portinLines);
    this.requestPortin.ban = this._cacheSvc.getFromSessionStorage(MANAGE_LINE_CONST.BAN);
    this.requestPortin.targetServiceName = SIM_CHANGE_CONST.PORTIN_TXT;

    const ngbModalOptions: NgbModalOptions = {
      backdrop: 'static',
      keyboard: false,
      container: '#am-container-custom',
    };
    this._loaderSvc.start();
    this.manageLineService.bulkTransferNumberProcessor(this.requestPortin).subscribe((data) => {
       this._loaderSvc.stop();
      if (data?.status === SIM_CHANGE_CONST.SUCCESS) {
        this.manageLineService.close();
        const successModalRef = this.modalService.open(SuccessComponent, ngbModalOptions);
        successModalRef.componentInstance.tagEnabledByCaller = true;
        successModalRef.componentInstance.nameTag = this.authoringContentData.bulkFlow.bulkUploadTransferNumberTitleTxt;
        successModalRef.componentInstance.modalBodyContent = this.authoringContentData.transferNumberAuthoring.confirmationMsgTxt
          .replace('{{emailID}}', _.get(JSON.parse(this._cacheSvc.getFromSessionStorage(COMMON_CONSTANTS.EUI_TOKEN_DATA)), 'logonId', ''));
        successModalRef.componentInstance.isPortIn = true;
        successModalRef.componentInstance.bulkUploadFlow = true;
        successModalRef.componentInstance.header = this.authoringContentData.transferNumberAuthoring.bulkLineSuccessModalTitle;
        // tslint:disable-next-line: max-line-length
        successModalRef.componentInstance.portInSuccessTransaction = this.authoringContentData.transferNumberAuthoring.bulktransactionNumberTxt
          .replace('{{transID}}', data.token);
        successModalRef.componentInstance.transactionID = data.token;
      } else {
        this.utilsSvc.errorHandling(null);
        this._loaderSvc.stop();
      }
    }, (err) => {
      //Handle error
      this._loaderSvc.stop();
      this.manageLineService.close();
      this.utilsSvc.errorHandling(err);
    });
  }

  isTransferNumberTransaction() {
    return this.bulkFlow === BULK_UPLOAD.TRANSFER_NUMBERS;
  }

  generateModalViewTag(modalInfo) {
    if (this.isTransferNumberTransaction()) {
      this.pdlService.ifEnabledGenerateModalViewTag(modalInfo);
    }
  }

  generateClickTag(clickInfo) {
    if (this.isTransferNumberTransaction()) {
      this.pdlService.ifEnabledGenerateClickTag(clickInfo);
    }
  }

  close() {
    this.manageLineService.close();
    this.stopValidationSetTimeout();
    this.generateClickTag({
      type: ANALYTICS.CLICK_TO_NAVIGATE,
      action: ANALYTICS.CLICK,
      ctaName: ANALYTICS.CLOSE,
      assetType: ANALYTICS.LINK,
      modalName: this.title,
      stage: ANALYTICS.INPROGRESSSTAGE,
      name: this.title
    });
  }

  cancel() {
    this.stopValidationSetTimeout();
    this.manageLineService.close();

    this.generateClickTag({
      type: ANALYTICS.CLICK_TO_NAVIGATE,
      action: ANALYTICS.CLICK,
      ctaName: ANALYTICS.CANCEL,
      assetType: ANALYTICS.BUTTON,
      modalName: this.title,
      stage: ANALYTICS.INPROGRESSSTAGE,
      name: this.title
    });
  }

  clickUploadReplaceFile(uploadOrReplace) {
    this.generateClickTag({
      type: ANALYTICS.CLICK_TO_NAVIGATE,
      action: ANALYTICS.CLICK,
      ctaName: uploadOrReplace,
      assetType: ANALYTICS.LINK,
      modalName: this.title,
      stage: ANALYTICS.INPROGRESSSTAGE,
      name: this.title
    });
  }

  setCancelSubscriberTemplateData() {
    this.templateObj = [];
    const temp1 = {};
    temp1[BULK_UPLOAD.BULK_PHONE_NUMBER_TXT] = "";
    temp1[BULK_UPLOAD.CANCEL_REASON] = "";
    temp1[BULK_UPLOAD.CANCEL_DATE] = "";

    this.templateObj.push(temp1);
  }

  submitDataAfterUpload() {
    this.ngbModalOptions = {
      backdrop: 'static',
      keyboard: false,
      container: '#am-container-custom',
    };
    ContentService.SetCache(BULK_UPLOAD.BULK_UPLOAD_REQUEST_KEY, this.uploadJsonData);
    this.requests = [];
    this.manageLineService.close();
    this.modalService.open(SubmitBulkUploadComponent, this.ngbModalOptions);
  }

  showDuplicatePhoneErrorMsg() {
    this.popuperror = this.authoringContentData?.transferNumberAuthoring?.duplicateNumberErrMsg ? this.authoringContentData.transferNumberAuthoring.duplicateNumberErrMsg : '';
  }

  validateTpopSheet(sheetData) {
    // tslint:disable-next-line: no-angle-bracket-type-assertion
    const colDefs = <ColumnDefinitionDateStr[]>TPOPColumnsDefinition;
    let totalInvalidRows = 0;
    let numRowIssues = 0;

    sheetData.forEach((data) => {
      const tempKeys = BULK_UPLOAD.TPOP_BULK_KEYS;
      numRowIssues = 0;
      let hasExpectedNumColumns = 0;

      tempKeys.forEach((key) => {
        if (key === BULK_UPLOAD.BULK_ACCOUNT_NUMBER_TXT) {
          hasExpectedNumColumns++;
          data[key] = data[key].toString().replace(/[^0-9]/g, '');
          const banValue = data[key];
          const colDef = colDefs.find((col) => col.headerName === BULK_UPLOAD.BULK_ACCOUNT_NUMBER_TXT);
          if (this.errorCheck(banValue, colDef) === 1) {
            numRowIssues++;
            return;
          }
        }
        if (key === BULK_UPLOAD.BULK_PHONE_NUMBER_TXT) {
          hasExpectedNumColumns++;
          data[key] = data[key].toString().replace(/[^0-9]/g, '');
          const phoneValue = data[key];
          const colDef = colDefs.find((col) => col.headerName === BULK_UPLOAD.BULK_PHONE_NUMBER_TXT);
          if (this.errorCheck(phoneValue, colDef) === 1) {
            numRowIssues++;
            return;
          }
        }
      });
      if (hasExpectedNumColumns !== tempKeys.length) {
        numRowIssues++;
      }
      totalInvalidRows = numRowIssues > 0 ? totalInvalidRows + 1 : totalInvalidRows;
      if (numRowIssues === 0) {
        this.validUploadData.push(data);
      }

    });

    return totalInvalidRows;
  }

  validateCancelSubscriberSheet(sheetData) {
    // tslint:disable-next-line: no-angle-bracket-type-assertion
    const colDefs = <ColumnDefinitionDateStr[]>cancelSubscriberColumnsDefinition;
    let totalInvalidRows = 0;
    let numRowIssues = 0;
    let cancelReasonValue = '';

    sheetData.forEach((data) => {
      const tempKeys = BULK_UPLOAD.CANCEL_SUBSCRIBER_KEYS;
      numRowIssues = 0;
      let hasExpectedNumColumns = 0;

      for (let key of tempKeys) {
        if (key === BULK_UPLOAD.BULK_PHONE_NUMBER_TXT) {
          hasExpectedNumColumns++;
          data[key] = data[key].toString().replace(/[^0-9]/g, '');
          const phoneValue = data[key];
          const colDef = colDefs.find((col) => col.headerName === BULK_UPLOAD.BULK_PHONE_NUMBER_TXT);
          if (this.errorCheck(phoneValue, colDef) === 1) {
            numRowIssues++;
            continue;
          }
        }
        if (key === BULK_UPLOAD.CANCEL_REASON) {
          hasExpectedNumColumns++;
          cancelReasonValue = data[key];
          const colDef = colDefs.find((col) => col.headerName === BULK_UPLOAD.CANCEL_REASON);
          if (this.errorCheck(cancelReasonValue, colDef) === 1) {
            numRowIssues++;
            continue;
          }
        }
        if (key === BULK_UPLOAD.CANCEL_DATE) {
          hasExpectedNumColumns++;
          const cancelDate = data[key];
          const colDef = colDefs.find((col) => col.headerName === BULK_UPLOAD.CANCEL_DATE);
          if (this.errorCheck(cancelDate, colDef) === 1) {
            numRowIssues++;
            continue;
          }
        }
      }

      if (hasExpectedNumColumns !== tempKeys.length) {
        numRowIssues++;
      }
      totalInvalidRows = numRowIssues > 0 ? totalInvalidRows + 1 : totalInvalidRows;
      if (numRowIssues === 0) {
        this.validUploadData.push(data);
      }

    });

    return totalInvalidRows;
  }

  validateChangeServiceSheet(sheetData) {
    const services = JSON.parse(this._cacheSvc.getFromSessionStorage(BULK_UPLOAD.CATALOG_SERVICES));
    // tslint:disable-next-line: no-angle-bracket-type-assertion
    const colDefs = <ColumnDefinition[]>changeServiceColumnsDefinition;
    let totalInvalidRows = 0;
    let numRowIssues = 0;

    sheetData.forEach((data) => {
      const tempKeys = Object.keys(data);
      numRowIssues = 0;
      let hasPhoneNumCol = false;

      for (let key of tempKeys) {
        if (key === BULK_UPLOAD.BULK_PHONE_NUMBER_TXT) {
          hasPhoneNumCol = true;
          data[key] = data[key].toString().replace(/[^0-9]/g, '');
          const phoneValue = data[key];
          const colDef = colDefs.find((col) => col.headerName === BULK_UPLOAD.BULK_PHONE_NUMBER_TXT);

          if (this.errorCheck(phoneValue, colDef) === 1) {
            numRowIssues++;
            continue;
          }
        } else {
          // Check Columns with Service Name
          if (services[key.toLocaleLowerCase()] === undefined) {
            // Column has Service name that is not known
            numRowIssues++
            continue;
          }
          // Get value without any white space
          const value = data[key].replace(/\s+/g, "");
          const colDef = colDefs.find((col) => col.headerName === 'ServiceAction');

          if (this.errorCheck(value, colDef) === 1) {
            numRowIssues++;
            continue;
          }
        }
      }

      if (Object.keys(sheetData[0])?.length <= 1) {
        numRowIssues++;
      }
      if (!hasPhoneNumCol) {
        numRowIssues++;
      }

      totalInvalidRows = numRowIssues > 0 ? totalInvalidRows + 1 : totalInvalidRows;
      if (numRowIssues === 0) {
        this.validUploadData.push(data);
      }
    });

    return totalInvalidRows;
  }

  makingDataForManagePairing() {
    if (this.selectedLines) {
      this.templateObj = [];
      const digitsLines = [];
      const gsmLines = [];
      let temp = {};
      for (const line of this.selectedLines) {
        temp = {};

        if (this.mngPairingSvc.isDIGITsLine(line?.lineType)) {
          temp[BULK_UPLOAD.MNG_PAIRING_MOBILE_LINE] = '';
          temp[BULK_UPLOAD.MNG_PAIRING_DIGITS_LINE] = line?.msisdn;
          temp[BULK_UPLOAD.MNG_PAIRING_ACTION] = '';
          digitsLines.push(temp);
        } else if (this.mngPairingSvc.isGSMLine(line?.productType)) {
          temp[BULK_UPLOAD.MNG_PAIRING_MOBILE_LINE] = line?.msisdn;
          temp[BULK_UPLOAD.MNG_PAIRING_DIGITS_LINE] = '';
          temp[BULK_UPLOAD.MNG_PAIRING_ACTION] = '';
          gsmLines.push(temp);
        }
      }
      this.templateObj = gsmLines.concat(digitsLines);
    }
  }

  uploadAgain(event){
    this.popuperror = null;
    this.getIncomingFile(event);
  }


  getIncomingFile(event) {
    this.popuperror = null;
    this.showTimeErrorBelowReviewStatement = false;
    if (event.target.files.length > 0) {
      const fileName = event.target.files[0].name;
      const extention = fileName.split('.').pop();

      if(extention == BULK_UPLOAD.CSV_TXT) {
        this.isExcel = false;
        ContentService.SetCache('template', BULK_UPLOAD.CSV_TXT);
        this.templateType = BULK_UPLOAD.CSV_TXT
        this.getIncomingfileCsv(event);
      } else if (extention == BULK_UPLOAD.XLSX_TXT) {
        this.isExcel = true;
        this.templateType = BULK_UPLOAD.XLSX_TXT
        ContentService.SetCache('template', BULK_UPLOAD.XLSX_TXT);
        this.getIncomingfileXlsx(event);
      } else {
        this.popuperror = this.authoringContentData.bulkFlow.popUpErrorExtention;
      }
    } else {
      this.popuperror = this.authoringContentData.bulkFlow.popUpErrorExtention;
    }
  }
}
